/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
var Object_pb = require('./Object_pb.js');
goog.exportSymbol('proto.ctpfront.proto.CancelOrder', null, global);
goog.exportSymbol('proto.ctpfront.proto.CancelOrderRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Capital', null, global);
goog.exportSymbol('proto.ctpfront.proto.CapitalReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.CapitalRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecord', null, global);
goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecordGetReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecordGetRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Dictionary', null, global);
goog.exportSymbol('proto.ctpfront.proto.Dominant', null, global);
goog.exportSymbol('proto.ctpfront.proto.GetLangLicenseRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.GetLangReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.GetLangRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.InsertOrderRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.LangPack', null, global);
goog.exportSymbol('proto.ctpfront.proto.License', null, global);
goog.exportSymbol('proto.ctpfront.proto.Login', null, global);
goog.exportSymbol('proto.ctpfront.proto.LoginReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.LoginRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.MaxOrderVolume', null, global);
goog.exportSymbol('proto.ctpfront.proto.MaxOrderVolumeRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Order', null, global);
goog.exportSymbol('proto.ctpfront.proto.OrderConditionGetReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.OrderConditionGetRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.OrderConditional', null, global);
goog.exportSymbol('proto.ctpfront.proto.OrderConditionalReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.OrderConditionalRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Position', null, global);
goog.exportSymbol('proto.ctpfront.proto.PositionDetail', null, global);
goog.exportSymbol('proto.ctpfront.proto.PositionDetailReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.PositionDetailRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.PositionReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.PositionRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Quote', null, global);
goog.exportSymbol('proto.ctpfront.proto.QuoteReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.QuoteRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Response', null, global);
goog.exportSymbol('proto.ctpfront.proto.Settlement', null, global);
goog.exportSymbol('proto.ctpfront.proto.SettlementRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubConditionList', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubConditionListRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubData', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubDataRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubTickReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.SubTickRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Subscribe', null, global);
goog.exportSymbol('proto.ctpfront.proto.Target', null, global);
goog.exportSymbol('proto.ctpfront.proto.TargetReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.TargetRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.TargetSelected', null, global);
goog.exportSymbol('proto.ctpfront.proto.TargetSelectedReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.TargetSelectedRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Trade', null, global);
goog.exportSymbol('proto.ctpfront.proto.TradeAccountPasswdUpdateReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.TradeAccountPasswdUpdateRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.UserPasswdUpdateReq', null, global);
goog.exportSymbol('proto.ctpfront.proto.UserPasswdUpdateRsp', null, global);
goog.exportSymbol('proto.ctpfront.proto.Word', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.LoginReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.LoginReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.LoginReq.displayName = 'proto.ctpfront.proto.LoginReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.LoginReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.LoginReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LoginReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.LoginReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            password: jspb.Message.getFieldWithDefault(msg, 3, ""),
            module: jspb.Message.getFieldWithDefault(msg, 4, ""),
            lang: jspb.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LoginReq}
 */
proto.ctpfront.proto.LoginReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.LoginReq;
    return proto.ctpfront.proto.LoginReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LoginReq}
 */
proto.ctpfront.proto.LoginReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setPassword(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setModule(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setLang(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.LoginReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.LoginReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.LoginReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getPassword();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getModule();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getLang();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.LoginReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LoginReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.LoginReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LoginReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string password = 3;
 * @return {string}
 */
proto.ctpfront.proto.LoginReq.prototype.getPassword = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LoginReq.prototype.setPassword = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string module = 4;
 * @return {string}
 */
proto.ctpfront.proto.LoginReq.prototype.getModule = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LoginReq.prototype.setModule = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string lang = 5;
 * @return {string}
 */
proto.ctpfront.proto.LoginReq.prototype.getLang = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LoginReq.prototype.setLang = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Login = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Login, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Login.displayName = 'proto.ctpfront.proto.Login';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Login.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Login.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Login} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Login.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 10, ""),
            account: jspb.Message.getFieldWithDefault(msg, 11, ""),
            password: jspb.Message.getFieldWithDefault(msg, 12, ""),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 13, ""),
            systemName: jspb.Message.getFieldWithDefault(msg, 14, ""),
            loginTime: jspb.Message.getFieldWithDefault(msg, 15, ""),
            maxOrderRef: jspb.Message.getFieldWithDefault(msg, 16, 0),
            frontId: jspb.Message.getFieldWithDefault(msg, 17, 0),
            sessionId: jspb.Message.getFieldWithDefault(msg, 18, 0),
            version: jspb.Message.getFieldWithDefault(msg, 19, ""),
            address: jspb.Message.getFieldWithDefault(msg, 20, ""),
            content: jspb.Message.getFieldWithDefault(msg, 21, ""),
            addressIos: jspb.Message.getFieldWithDefault(msg, 22, ""),
            versionIos: jspb.Message.getFieldWithDefault(msg, 23, ""),
            contentIos: jspb.Message.getFieldWithDefault(msg, 24, ""),
            crmAddress: jspb.Message.getFieldWithDefault(msg, 25, ""),
            langTs: jspb.Message.getFieldWithDefault(msg, 27, ""),
            licenseTs: jspb.Message.getFieldWithDefault(msg, 28, ""),
            module: jspb.Message.getFieldWithDefault(msg, 29, ""),
            lang: jspb.Message.getFieldWithDefault(msg, 30, ""),
            userName: jspb.Message.getFieldWithDefault(msg, 31, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Login}
 */
proto.ctpfront.proto.Login.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Login;
    return proto.ctpfront.proto.Login.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Login} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Login}
 */
proto.ctpfront.proto.Login.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 10:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 11:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 12:
                var value = /** @type {string} */ (reader.readString());
                msg.setPassword(value);
                break;
            case 13:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 14:
                var value = /** @type {string} */ (reader.readString());
                msg.setSystemName(value);
                break;
            case 15:
                var value = /** @type {string} */ (reader.readString());
                msg.setLoginTime(value);
                break;
            case 16:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setMaxOrderRef(value);
                break;
            case 17:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setFrontId(value);
                break;
            case 18:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setSessionId(value);
                break;
            case 19:
                var value = /** @type {string} */ (reader.readString());
                msg.setVersion(value);
                break;
            case 20:
                var value = /** @type {string} */ (reader.readString());
                msg.setAddress(value);
                break;
            case 21:
                var value = /** @type {string} */ (reader.readString());
                msg.setContent(value);
                break;
            case 22:
                var value = /** @type {string} */ (reader.readString());
                msg.setAddressIos(value);
                break;
            case 23:
                var value = /** @type {string} */ (reader.readString());
                msg.setVersionIos(value);
                break;
            case 24:
                var value = /** @type {string} */ (reader.readString());
                msg.setContentIos(value);
                break;
            case 25:
                var value = /** @type {string} */ (reader.readString());
                msg.setCrmAddress(value);
                break;
            case 27:
                var value = /** @type {string} */ (reader.readString());
                msg.setLangTs(value);
                break;
            case 28:
                var value = /** @type {string} */ (reader.readString());
                msg.setLicenseTs(value);
                break;
            case 29:
                var value = /** @type {string} */ (reader.readString());
                msg.setModule(value);
                break;
            case 30:
                var value = /** @type {string} */ (reader.readString());
                msg.setLang(value);
                break;
            case 31:
                var value = /** @type {string} */ (reader.readString());
                msg.setUserName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Login.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Login.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Login} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Login.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(10, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(11, f);
    }
    f = message.getPassword();
    if (f.length > 0) {
        writer.writeString(12, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(13, f);
    }
    f = message.getSystemName();
    if (f.length > 0) {
        writer.writeString(14, f);
    }
    f = message.getLoginTime();
    if (f.length > 0) {
        writer.writeString(15, f);
    }
    f = message.getMaxOrderRef();
    if (f !== 0) {
        writer.writeUint32(16, f);
    }
    f = message.getFrontId();
    if (f !== 0) {
        writer.writeInt32(17, f);
    }
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeInt32(18, f);
    }
    f = message.getVersion();
    if (f.length > 0) {
        writer.writeString(19, f);
    }
    f = message.getAddress();
    if (f.length > 0) {
        writer.writeString(20, f);
    }
    f = message.getContent();
    if (f.length > 0) {
        writer.writeString(21, f);
    }
    f = message.getAddressIos();
    if (f.length > 0) {
        writer.writeString(22, f);
    }
    f = message.getVersionIos();
    if (f.length > 0) {
        writer.writeString(23, f);
    }
    f = message.getContentIos();
    if (f.length > 0) {
        writer.writeString(24, f);
    }
    f = message.getCrmAddress();
    if (f.length > 0) {
        writer.writeString(25, f);
    }
    f = message.getLangTs();
    if (f.length > 0) {
        writer.writeString(27, f);
    }
    f = message.getLicenseTs();
    if (f.length > 0) {
        writer.writeString(28, f);
    }
    f = message.getModule();
    if (f.length > 0) {
        writer.writeString(29, f);
    }
    f = message.getLang();
    if (f.length > 0) {
        writer.writeString(30, f);
    }
    f = message.getUserName();
    if (f.length > 0) {
        writer.writeString(31, f);
    }
};
/**
 * optional string broker = 10;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string account = 11;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string password = 12;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getPassword = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setPassword = function (value) {
    jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string trading_day = 13;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string system_name = 14;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getSystemName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setSystemName = function (value) {
    jspb.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string login_time = 15;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getLoginTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setLoginTime = function (value) {
    jspb.Message.setProto3StringField(this, 15, value);
};
/**
 * optional uint32 max_order_ref = 16;
 * @return {number}
 */
proto.ctpfront.proto.Login.prototype.getMaxOrderRef = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Login.prototype.setMaxOrderRef = function (value) {
    jspb.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 front_id = 17;
 * @return {number}
 */
proto.ctpfront.proto.Login.prototype.getFrontId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Login.prototype.setFrontId = function (value) {
    jspb.Message.setProto3IntField(this, 17, value);
};
/**
 * optional int32 session_id = 18;
 * @return {number}
 */
proto.ctpfront.proto.Login.prototype.getSessionId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Login.prototype.setSessionId = function (value) {
    jspb.Message.setProto3IntField(this, 18, value);
};
/**
 * optional string version = 19;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getVersion = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setVersion = function (value) {
    jspb.Message.setProto3StringField(this, 19, value);
};
/**
 * optional string address = 20;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getAddress = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setAddress = function (value) {
    jspb.Message.setProto3StringField(this, 20, value);
};
/**
 * optional string content = 21;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getContent = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setContent = function (value) {
    jspb.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string address_ios = 22;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getAddressIos = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setAddressIos = function (value) {
    jspb.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string version_ios = 23;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getVersionIos = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setVersionIos = function (value) {
    jspb.Message.setProto3StringField(this, 23, value);
};
/**
 * optional string content_ios = 24;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getContentIos = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setContentIos = function (value) {
    jspb.Message.setProto3StringField(this, 24, value);
};
/**
 * optional string crm_address = 25;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getCrmAddress = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setCrmAddress = function (value) {
    jspb.Message.setProto3StringField(this, 25, value);
};
/**
 * optional string lang_ts = 27;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getLangTs = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setLangTs = function (value) {
    jspb.Message.setProto3StringField(this, 27, value);
};
/**
 * optional string license_ts = 28;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getLicenseTs = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setLicenseTs = function (value) {
    jspb.Message.setProto3StringField(this, 28, value);
};
/**
 * optional string module = 29;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getModule = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setModule = function (value) {
    jspb.Message.setProto3StringField(this, 29, value);
};
/**
 * optional string lang = 30;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getLang = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setLang = function (value) {
    jspb.Message.setProto3StringField(this, 30, value);
};
/**
 * optional string user_name = 31;
 * @return {string}
 */
proto.ctpfront.proto.Login.prototype.getUserName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Login.prototype.setUserName = function (value) {
    jspb.Message.setProto3StringField(this, 31, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.LoginRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.LoginRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.LoginRsp.displayName = 'proto.ctpfront.proto.LoginRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.LoginRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.LoginRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LoginRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.LoginRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Login.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LoginRsp}
 */
proto.ctpfront.proto.LoginRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.LoginRsp;
    return proto.ctpfront.proto.LoginRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LoginRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LoginRsp}
 */
proto.ctpfront.proto.LoginRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Login;
                reader.readMessage(value, proto.ctpfront.proto.Login.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.LoginRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.LoginRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LoginRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.LoginRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.Login.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.LoginRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.LoginRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.LoginRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.LoginRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Login data = 10;
 * @return {?proto.ctpfront.proto.Login}
 */
proto.ctpfront.proto.LoginRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Login} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Login, 10));
};
/** @param {?proto.ctpfront.proto.Login|undefined} value */
proto.ctpfront.proto.LoginRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.LoginRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.LoginRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.MaxOrderVolume = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.MaxOrderVolume, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.MaxOrderVolume.displayName = 'proto.ctpfront.proto.MaxOrderVolume';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.MaxOrderVolume.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.MaxOrderVolume.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.MaxOrderVolume} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.MaxOrderVolume.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            direction: jspb.Message.getFieldWithDefault(msg, 3, 0),
            offset: jspb.Message.getFieldWithDefault(msg, 4, 0),
            hedge: jspb.Message.getFieldWithDefault(msg, 5, 0),
            maxVolume: jspb.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.MaxOrderVolume}
 */
proto.ctpfront.proto.MaxOrderVolume.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.MaxOrderVolume;
    return proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.MaxOrderVolume} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.MaxOrderVolume}
 */
proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setDirection(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setOffset(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setHedge(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setMaxVolume(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.MaxOrderVolume} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getDirection();
    if (f !== 0) {
        writer.writeInt32(3, f);
    }
    f = message.getOffset();
    if (f !== 0) {
        writer.writeInt32(4, f);
    }
    f = message.getHedge();
    if (f !== 0) {
        writer.writeInt32(5, f);
    }
    f = message.getMaxVolume();
    if (f !== 0) {
        writer.writeInt32(6, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 direction = 3;
 * @return {number}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setDirection = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 offset = 4;
 * @return {number}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getOffset = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};
/** @param {number} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setOffset = function (value) {
    jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 hedge = 5;
 * @return {number}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getHedge = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};
/** @param {number} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setHedge = function (value) {
    jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 max_volume = 6;
 * @return {number}
 */
proto.ctpfront.proto.MaxOrderVolume.prototype.getMaxVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.MaxOrderVolume.prototype.setMaxVolume = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.MaxOrderVolumeRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.MaxOrderVolumeRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.MaxOrderVolumeRsp.displayName = 'proto.ctpfront.proto.MaxOrderVolumeRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.MaxOrderVolumeRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.MaxOrderVolumeRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.MaxOrderVolume.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.MaxOrderVolumeRsp}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.MaxOrderVolumeRsp;
    return proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.MaxOrderVolumeRsp}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.MaxOrderVolume;
                reader.readMessage(value, proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.MaxOrderVolumeRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional MaxOrderVolume data = 10;
 * @return {?proto.ctpfront.proto.MaxOrderVolume}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.MaxOrderVolume} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.MaxOrderVolume, 10));
};
/** @param {?proto.ctpfront.proto.MaxOrderVolume|undefined} value */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubData = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SubData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubData.displayName = 'proto.ctpfront.proto.SubData';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubData.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubData.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubData} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubData.toObject = function (includeInstance, msg) {
        var f, obj = {
            data: jspb.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubData}
 */
proto.ctpfront.proto.SubData.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubData;
    return proto.ctpfront.proto.SubData.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubData}
 */
proto.ctpfront.proto.SubData.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubData.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubData.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getData();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
};
/**
 * optional uint32 data = 1;
 * @return {number}
 */
proto.ctpfront.proto.SubData.prototype.getData = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};
/** @param {number} value */
proto.ctpfront.proto.SubData.prototype.setData = function (value) {
    jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubDataRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SubDataRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubDataRsp.displayName = 'proto.ctpfront.proto.SubDataRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubDataRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubDataRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubDataRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubDataRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: jspb.Message.getFieldWithDefault(msg, 10, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubDataRsp}
 */
proto.ctpfront.proto.SubDataRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubDataRsp;
    return proto.ctpfront.proto.SubDataRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubDataRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubDataRsp}
 */
proto.ctpfront.proto.SubDataRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubDataRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubDataRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubDataRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubDataRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f !== 0) {
        writer.writeUint32(10, f);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.SubDataRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.SubDataRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.SubDataRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SubDataRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional uint32 data = 10;
 * @return {number}
 */
proto.ctpfront.proto.SubDataRsp.prototype.getData = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};
/** @param {number} value */
proto.ctpfront.proto.SubDataRsp.prototype.setData = function (value) {
    jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Order = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Order.displayName = 'proto.ctpfront.proto.Order';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Order.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Order.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Order} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Order.toObject = function (includeInstance, msg) {
        var f, obj = {
            orderRef: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
            account: jspb.Message.getFieldWithDefault(msg, 4, ""),
            price: +jspb.Message.getFieldWithDefault(msg, 7, 0.0),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 20, 0),
            priceType: jspb.Message.getFieldWithDefault(msg, 21, 0),
            volume: jspb.Message.getFieldWithDefault(msg, 23, 0),
            direction: jspb.Message.getFieldWithDefault(msg, 24, 0),
            offset: jspb.Message.getFieldWithDefault(msg, 25, 0),
            hedge: jspb.Message.getFieldWithDefault(msg, 26, 0),
            minVolume: jspb.Message.getFieldWithDefault(msg, 27, 0),
            volumeType: jspb.Message.getFieldWithDefault(msg, 28, 0),
            validTimeType: jspb.Message.getFieldWithDefault(msg, 29, 0),
            orderId: jspb.Message.getFieldWithDefault(msg, 40, ""),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 41, ""),
            stateDetail: jspb.Message.getFieldWithDefault(msg, 42, ""),
            insertTime: jspb.Message.getFieldWithDefault(msg, 43, ""),
            state: jspb.Message.getFieldWithDefault(msg, 44, 0),
            tradedVolume: jspb.Message.getFieldWithDefault(msg, 45, 0),
            cancelTime: jspb.Message.getFieldWithDefault(msg, 46, ""),
            orderSeq: jspb.Message.getFieldWithDefault(msg, 47, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Order}
 */
proto.ctpfront.proto.Order.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Order;
    return proto.ctpfront.proto.Order.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Order}
 */
proto.ctpfront.proto.Order.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderRef(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 7:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPrice(value);
                break;
            case 20:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 21:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setPriceType(value);
                break;
            case 23:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setVolume(value);
                break;
            case 24:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setDirection(value);
                break;
            case 25:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOffset(value);
                break;
            case 26:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setHedge(value);
                break;
            case 27:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setMinVolume(value);
                break;
            case 28:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setVolumeType(value);
                break;
            case 29:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setValidTimeType(value);
                break;
            case 40:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderId(value);
                break;
            case 41:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 42:
                var value = /** @type {string} */ (reader.readString());
                msg.setStateDetail(value);
                break;
            case 43:
                var value = /** @type {string} */ (reader.readString());
                msg.setInsertTime(value);
                break;
            case 44:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setState(value);
                break;
            case 45:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setTradedVolume(value);
                break;
            case 46:
                var value = /** @type {string} */ (reader.readString());
                msg.setCancelTime(value);
                break;
            case 47:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderSeq(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Order.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Order.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Order.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getOrderRef();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getPrice();
    if (f !== 0.0) {
        writer.writeDouble(7, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(20, f);
    }
    f = message.getPriceType();
    if (f !== 0) {
        writer.writeUint32(21, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeUint32(23, f);
    }
    f = message.getDirection();
    if (f !== 0) {
        writer.writeUint32(24, f);
    }
    f = message.getOffset();
    if (f !== 0) {
        writer.writeUint32(25, f);
    }
    f = message.getHedge();
    if (f !== 0) {
        writer.writeUint32(26, f);
    }
    f = message.getMinVolume();
    if (f !== 0) {
        writer.writeUint32(27, f);
    }
    f = message.getVolumeType();
    if (f !== 0) {
        writer.writeUint32(28, f);
    }
    f = message.getValidTimeType();
    if (f !== 0) {
        writer.writeUint32(29, f);
    }
    f = message.getOrderId();
    if (f.length > 0) {
        writer.writeString(40, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(41, f);
    }
    f = message.getStateDetail();
    if (f.length > 0) {
        writer.writeString(42, f);
    }
    f = message.getInsertTime();
    if (f.length > 0) {
        writer.writeString(43, f);
    }
    f = message.getState();
    if (f !== 0) {
        writer.writeUint32(44, f);
    }
    f = message.getTradedVolume();
    if (f !== 0) {
        writer.writeUint32(45, f);
    }
    f = message.getCancelTime();
    if (f.length > 0) {
        writer.writeString(46, f);
    }
    f = message.getOrderSeq();
    if (f.length > 0) {
        writer.writeString(47, f);
    }
};
/**
 * optional string order_ref = 1;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getOrderRef = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setOrderRef = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string broker = 3;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string account = 4;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional double price = 7;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 7, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional uint32 exchange_id = 20;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 20, value);
};
/**
 * optional uint32 price_type = 21;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getPriceType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setPriceType = function (value) {
    jspb.Message.setProto3IntField(this, 21, value);
};
/**
 * optional uint32 volume = 23;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 23, value);
};
/**
 * optional uint32 direction = 24;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setDirection = function (value) {
    jspb.Message.setProto3IntField(this, 24, value);
};
/**
 * optional uint32 offset = 25;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getOffset = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setOffset = function (value) {
    jspb.Message.setProto3IntField(this, 25, value);
};
/**
 * optional uint32 hedge = 26;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getHedge = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setHedge = function (value) {
    jspb.Message.setProto3IntField(this, 26, value);
};
/**
 * optional uint32 min_volume = 27;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getMinVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setMinVolume = function (value) {
    jspb.Message.setProto3IntField(this, 27, value);
};
/**
 * optional uint32 volume_type = 28;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getVolumeType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setVolumeType = function (value) {
    jspb.Message.setProto3IntField(this, 28, value);
};
/**
 * optional uint32 valid_time_type = 29;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getValidTimeType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setValidTimeType = function (value) {
    jspb.Message.setProto3IntField(this, 29, value);
};
/**
 * optional string order_id = 40;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getOrderId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setOrderId = function (value) {
    jspb.Message.setProto3StringField(this, 40, value);
};
/**
 * optional string trading_day = 41;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 41, value);
};
/**
 * optional string state_detail = 42;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getStateDetail = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setStateDetail = function (value) {
    jspb.Message.setProto3StringField(this, 42, value);
};
/**
 * optional string insert_time = 43;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getInsertTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setInsertTime = function (value) {
    jspb.Message.setProto3StringField(this, 43, value);
};
/**
 * optional uint32 state = 44;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getState = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setState = function (value) {
    jspb.Message.setProto3IntField(this, 44, value);
};
/**
 * optional uint32 traded_volume = 45;
 * @return {number}
 */
proto.ctpfront.proto.Order.prototype.getTradedVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Order.prototype.setTradedVolume = function (value) {
    jspb.Message.setProto3IntField(this, 45, value);
};
/**
 * optional string cancel_time = 46;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getCancelTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setCancelTime = function (value) {
    jspb.Message.setProto3StringField(this, 46, value);
};
/**
 * optional string order_seq = 47;
 * @return {string}
 */
proto.ctpfront.proto.Order.prototype.getOrderSeq = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Order.prototype.setOrderSeq = function (value) {
    jspb.Message.setProto3StringField(this, 47, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Trade = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Trade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Trade.displayName = 'proto.ctpfront.proto.Trade';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Trade.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Trade.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Trade} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Trade.toObject = function (includeInstance, msg) {
        var f, obj = {
            orderRef: jspb.Message.getFieldWithDefault(msg, 1, ""),
            orderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            tradeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
            broker: jspb.Message.getFieldWithDefault(msg, 4, ""),
            account: jspb.Message.getFieldWithDefault(msg, 5, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 6, ""),
            tradeTime: jspb.Message.getFieldWithDefault(msg, 7, ""),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 8, ""),
            price: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 11, 0),
            volume: jspb.Message.getFieldWithDefault(msg, 12, 0),
            direction: jspb.Message.getFieldWithDefault(msg, 13, 0),
            offset: jspb.Message.getFieldWithDefault(msg, 14, 0),
            hedge: jspb.Message.getFieldWithDefault(msg, 15, 0),
            orderSeq: jspb.Message.getFieldWithDefault(msg, 16, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Trade}
 */
proto.ctpfront.proto.Trade.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Trade;
    return proto.ctpfront.proto.Trade.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Trade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Trade}
 */
proto.ctpfront.proto.Trade.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderRef(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradeId(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 6:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 7:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradeTime(value);
                break;
            case 8:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPrice(value);
                break;
            case 11:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 12:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setVolume(value);
                break;
            case 13:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setDirection(value);
                break;
            case 14:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOffset(value);
                break;
            case 15:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setHedge(value);
                break;
            case 16:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderSeq(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Trade.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Trade.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Trade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Trade.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getOrderRef();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getOrderId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getTradeId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(6, f);
    }
    f = message.getTradeTime();
    if (f.length > 0) {
        writer.writeString(7, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(8, f);
    }
    f = message.getPrice();
    if (f !== 0.0) {
        writer.writeDouble(9, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(11, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeUint32(12, f);
    }
    f = message.getDirection();
    if (f !== 0) {
        writer.writeUint32(13, f);
    }
    f = message.getOffset();
    if (f !== 0) {
        writer.writeUint32(14, f);
    }
    f = message.getHedge();
    if (f !== 0) {
        writer.writeUint32(15, f);
    }
    f = message.getOrderSeq();
    if (f.length > 0) {
        writer.writeString(16, f);
    }
};
/**
 * optional string order_ref = 1;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getOrderRef = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setOrderRef = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getOrderId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setOrderId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string trade_id = 3;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getTradeId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setTradeId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string broker = 4;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string account = 5;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string target_id = 6;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string trade_time = 7;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getTradeTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setTradeTime = function (value) {
    jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string trading_day = 8;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional double price = 9;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional uint32 exchange_id = 11;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional uint32 volume = 12;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 12, value);
};
/**
 * optional uint32 direction = 13;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setDirection = function (value) {
    jspb.Message.setProto3IntField(this, 13, value);
};
/**
 * optional uint32 offset = 14;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getOffset = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setOffset = function (value) {
    jspb.Message.setProto3IntField(this, 14, value);
};
/**
 * optional uint32 hedge = 15;
 * @return {number}
 */
proto.ctpfront.proto.Trade.prototype.getHedge = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Trade.prototype.setHedge = function (value) {
    jspb.Message.setProto3IntField(this, 15, value);
};
/**
 * optional string order_seq = 16;
 * @return {string}
 */
proto.ctpfront.proto.Trade.prototype.getOrderSeq = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Trade.prototype.setOrderSeq = function (value) {
    jspb.Message.setProto3StringField(this, 16, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.CancelOrder = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.CancelOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.CancelOrder.displayName = 'proto.ctpfront.proto.CancelOrder';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.CancelOrder.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.CancelOrder.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CancelOrder} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.CancelOrder.toObject = function (includeInstance, msg) {
        var f, obj = {
            orderRef: jspb.Message.getFieldWithDefault(msg, 1, ""),
            orderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
            account: jspb.Message.getFieldWithDefault(msg, 4, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CancelOrder}
 */
proto.ctpfront.proto.CancelOrder.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.CancelOrder;
    return proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CancelOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CancelOrder}
 */
proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderRef(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setOrderId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.CancelOrder.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CancelOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getOrderRef();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getOrderId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
};
/**
 * optional string order_ref = 1;
 * @return {string}
 */
proto.ctpfront.proto.CancelOrder.prototype.getOrderRef = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.CancelOrder.prototype.setOrderRef = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.CancelOrder.prototype.getOrderId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.CancelOrder.prototype.setOrderId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string broker = 3;
 * @return {string}
 */
proto.ctpfront.proto.CancelOrder.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.CancelOrder.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string account = 4;
 * @return {string}
 */
proto.ctpfront.proto.CancelOrder.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.CancelOrder.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint32 exchange_id = 6;
 * @return {number}
 */
proto.ctpfront.proto.CancelOrder.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.CancelOrder.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.InsertOrderRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.InsertOrderRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.InsertOrderRsp.displayName = 'proto.ctpfront.proto.InsertOrderRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.InsertOrderRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.InsertOrderRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.InsertOrderRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.InsertOrderRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Order.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.InsertOrderRsp}
 */
proto.ctpfront.proto.InsertOrderRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.InsertOrderRsp;
    return proto.ctpfront.proto.InsertOrderRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.InsertOrderRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.InsertOrderRsp}
 */
proto.ctpfront.proto.InsertOrderRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.Order;
                reader.readMessage(value, proto.ctpfront.proto.Order.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.InsertOrderRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.InsertOrderRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.InsertOrderRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.InsertOrderRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.Order.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.InsertOrderRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.InsertOrderRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.InsertOrderRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.InsertOrderRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Order data = 2;
 * @return {?proto.ctpfront.proto.Order}
 */
proto.ctpfront.proto.InsertOrderRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Order} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Order, 2));
};
/** @param {?proto.ctpfront.proto.Order|undefined} value */
proto.ctpfront.proto.InsertOrderRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.InsertOrderRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.InsertOrderRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.CancelOrderRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.CancelOrderRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.CancelOrderRsp.displayName = 'proto.ctpfront.proto.CancelOrderRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.CancelOrderRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.CancelOrderRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CancelOrderRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.CancelOrderRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.CancelOrder.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CancelOrderRsp}
 */
proto.ctpfront.proto.CancelOrderRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.CancelOrderRsp;
    return proto.ctpfront.proto.CancelOrderRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CancelOrderRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CancelOrderRsp}
 */
proto.ctpfront.proto.CancelOrderRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.CancelOrder;
                reader.readMessage(value, proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.CancelOrderRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.CancelOrderRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CancelOrderRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.CancelOrderRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.CancelOrderRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.CancelOrderRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.CancelOrderRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.CancelOrderRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional CancelOrder data = 2;
 * @return {?proto.ctpfront.proto.CancelOrder}
 */
proto.ctpfront.proto.CancelOrderRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.CancelOrder} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.CancelOrder, 2));
};
/** @param {?proto.ctpfront.proto.CancelOrder|undefined} value */
proto.ctpfront.proto.CancelOrderRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.CancelOrderRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.CancelOrderRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.CapitalReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.CapitalReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.CapitalReq.displayName = 'proto.ctpfront.proto.CapitalReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.CapitalReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.CapitalReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CapitalReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.CapitalReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CapitalReq}
 */
proto.ctpfront.proto.CapitalReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.CapitalReq;
    return proto.ctpfront.proto.CapitalReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CapitalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CapitalReq}
 */
proto.ctpfront.proto.CapitalReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.CapitalReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.CapitalReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CapitalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.CapitalReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.CapitalReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.CapitalReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Capital = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Capital, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Capital.displayName = 'proto.ctpfront.proto.Capital';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Capital.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Capital.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Capital} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Capital.toObject = function (includeInstance, msg) {
        var f, obj = {
            available: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
            balance: +jspb.Message.getFieldWithDefault(msg, 2, 0.0),
            cashIn: +jspb.Message.getFieldWithDefault(msg, 3, 0.0),
            account: jspb.Message.getFieldWithDefault(msg, 5, ""),
            closeProfit: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
            commission: +jspb.Message.getFieldWithDefault(msg, 7, 0.0),
            credit: +jspb.Message.getFieldWithDefault(msg, 8, 0.0),
            currMargin: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
            deposit: +jspb.Message.getFieldWithDefault(msg, 10, 0.0),
            frozenCommission: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
            frozenMargin: +jspb.Message.getFieldWithDefault(msg, 14, 0.0),
            interest: +jspb.Message.getFieldWithDefault(msg, 15, 0.0),
            interestBase: +jspb.Message.getFieldWithDefault(msg, 16, 0.0),
            frozenCash: +jspb.Message.getFieldWithDefault(msg, 17, 0.0),
            positionProfit: +jspb.Message.getFieldWithDefault(msg, 18, 0.0),
            preBalance: +jspb.Message.getFieldWithDefault(msg, 19, 0.0),
            withdraw: +jspb.Message.getFieldWithDefault(msg, 20, 0.0),
            withdrawQuota: +jspb.Message.getFieldWithDefault(msg, 21, 0.0),
            currencyId: jspb.Message.getFieldWithDefault(msg, 22, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Capital}
 */
proto.ctpfront.proto.Capital.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Capital;
    return proto.ctpfront.proto.Capital.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Capital} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Capital}
 */
proto.ctpfront.proto.Capital.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setAvailable(value);
                break;
            case 2:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setBalance(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCashIn(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCloseProfit(value);
                break;
            case 7:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCommission(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCredit(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCurrMargin(value);
                break;
            case 10:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setDeposit(value);
                break;
            case 13:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozenCommission(value);
                break;
            case 14:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozenMargin(value);
                break;
            case 15:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setInterest(value);
                break;
            case 16:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setInterestBase(value);
                break;
            case 17:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozenCash(value);
                break;
            case 18:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPositionProfit(value);
                break;
            case 19:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPreBalance(value);
                break;
            case 20:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setWithdraw(value);
                break;
            case 21:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setWithdrawQuota(value);
                break;
            case 22:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setCurrencyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Capital.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Capital.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Capital} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Capital.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAvailable();
    if (f !== 0.0) {
        writer.writeDouble(1, f);
    }
    f = message.getBalance();
    if (f !== 0.0) {
        writer.writeDouble(2, f);
    }
    f = message.getCashIn();
    if (f !== 0.0) {
        writer.writeDouble(3, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
    f = message.getCloseProfit();
    if (f !== 0.0) {
        writer.writeDouble(6, f);
    }
    f = message.getCommission();
    if (f !== 0.0) {
        writer.writeDouble(7, f);
    }
    f = message.getCredit();
    if (f !== 0.0) {
        writer.writeDouble(8, f);
    }
    f = message.getCurrMargin();
    if (f !== 0.0) {
        writer.writeDouble(9, f);
    }
    f = message.getDeposit();
    if (f !== 0.0) {
        writer.writeDouble(10, f);
    }
    f = message.getFrozenCommission();
    if (f !== 0.0) {
        writer.writeDouble(13, f);
    }
    f = message.getFrozenMargin();
    if (f !== 0.0) {
        writer.writeDouble(14, f);
    }
    f = message.getInterest();
    if (f !== 0.0) {
        writer.writeDouble(15, f);
    }
    f = message.getInterestBase();
    if (f !== 0.0) {
        writer.writeDouble(16, f);
    }
    f = message.getFrozenCash();
    if (f !== 0.0) {
        writer.writeDouble(17, f);
    }
    f = message.getPositionProfit();
    if (f !== 0.0) {
        writer.writeDouble(18, f);
    }
    f = message.getPreBalance();
    if (f !== 0.0) {
        writer.writeDouble(19, f);
    }
    f = message.getWithdraw();
    if (f !== 0.0) {
        writer.writeDouble(20, f);
    }
    f = message.getWithdrawQuota();
    if (f !== 0.0) {
        writer.writeDouble(21, f);
    }
    f = message.getCurrencyId();
    if (f !== 0) {
        writer.writeUint32(22, f);
    }
};
/**
 * optional double available = 1;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getAvailable = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setAvailable = function (value) {
    jspb.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional double balance = 2;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getBalance = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setBalance = function (value) {
    jspb.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional double cash_in = 3;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCashIn = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 3, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCashIn = function (value) {
    jspb.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional string account = 5;
 * @return {string}
 */
proto.ctpfront.proto.Capital.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Capital.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional double close_profit = 6;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCloseProfit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCloseProfit = function (value) {
    jspb.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional double commission = 7;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCommission = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 7, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCommission = function (value) {
    jspb.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional double credit = 8;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCredit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 8, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCredit = function (value) {
    jspb.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional double curr_margin = 9;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCurrMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCurrMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional double deposit = 10;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getDeposit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 10, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setDeposit = function (value) {
    jspb.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional double frozen_commission = 13;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getFrozenCommission = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 13, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setFrozenCommission = function (value) {
    jspb.Message.setProto3FloatField(this, 13, value);
};
/**
 * optional double frozen_margin = 14;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getFrozenMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 14, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setFrozenMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 14, value);
};
/**
 * optional double interest = 15;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getInterest = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 15, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setInterest = function (value) {
    jspb.Message.setProto3FloatField(this, 15, value);
};
/**
 * optional double interest_base = 16;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getInterestBase = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 16, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setInterestBase = function (value) {
    jspb.Message.setProto3FloatField(this, 16, value);
};
/**
 * optional double frozen_cash = 17;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getFrozenCash = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 17, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setFrozenCash = function (value) {
    jspb.Message.setProto3FloatField(this, 17, value);
};
/**
 * optional double position_profit = 18;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getPositionProfit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 18, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setPositionProfit = function (value) {
    jspb.Message.setProto3FloatField(this, 18, value);
};
/**
 * optional double pre_balance = 19;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getPreBalance = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 19, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setPreBalance = function (value) {
    jspb.Message.setProto3FloatField(this, 19, value);
};
/**
 * optional double withdraw = 20;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getWithdraw = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 20, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setWithdraw = function (value) {
    jspb.Message.setProto3FloatField(this, 20, value);
};
/**
 * optional double withdraw_quota = 21;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getWithdrawQuota = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 21, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setWithdrawQuota = function (value) {
    jspb.Message.setProto3FloatField(this, 21, value);
};
/**
 * optional uint32 currency_id = 22;
 * @return {number}
 */
proto.ctpfront.proto.Capital.prototype.getCurrencyId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Capital.prototype.setCurrencyId = function (value) {
    jspb.Message.setProto3IntField(this, 22, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.CapitalRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.CapitalRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.CapitalRsp.displayName = 'proto.ctpfront.proto.CapitalRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.CapitalRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.CapitalRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CapitalRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.CapitalRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Capital.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CapitalRsp}
 */
proto.ctpfront.proto.CapitalRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.CapitalRsp;
    return proto.ctpfront.proto.CapitalRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CapitalRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CapitalRsp}
 */
proto.ctpfront.proto.CapitalRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Capital;
                reader.readMessage(value, proto.ctpfront.proto.Capital.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.CapitalRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.CapitalRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CapitalRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.CapitalRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.Capital.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.CapitalRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.CapitalRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.CapitalRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.CapitalRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Capital data = 10;
 * @return {?proto.ctpfront.proto.Capital}
 */
proto.ctpfront.proto.CapitalRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Capital} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Capital, 10));
};
/** @param {?proto.ctpfront.proto.Capital|undefined} value */
proto.ctpfront.proto.CapitalRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.CapitalRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.CapitalRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Settlement = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Settlement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Settlement.displayName = 'proto.ctpfront.proto.Settlement';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Settlement.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Settlement.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Settlement} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Settlement.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, ""),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 2, ""),
            settlementId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            broker: jspb.Message.getFieldWithDefault(msg, 4, ""),
            content: jspb.Message.getFieldWithDefault(msg, 5, ""),
            currencyId: jspb.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Settlement}
 */
proto.ctpfront.proto.Settlement.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Settlement;
    return proto.ctpfront.proto.Settlement.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Settlement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Settlement}
 */
proto.ctpfront.proto.Settlement.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setSettlementId(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setContent(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setCurrencyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Settlement.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Settlement.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Settlement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Settlement.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getSettlementId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getContent();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
    f = message.getCurrencyId();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.Settlement.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Settlement.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string trading_day = 2;
 * @return {string}
 */
proto.ctpfront.proto.Settlement.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Settlement.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint32 settlement_id = 3;
 * @return {number}
 */
proto.ctpfront.proto.Settlement.prototype.getSettlementId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Settlement.prototype.setSettlementId = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string broker = 4;
 * @return {string}
 */
proto.ctpfront.proto.Settlement.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Settlement.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string content = 5;
 * @return {string}
 */
proto.ctpfront.proto.Settlement.prototype.getContent = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Settlement.prototype.setContent = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional uint32 currency_id = 6;
 * @return {number}
 */
proto.ctpfront.proto.Settlement.prototype.getCurrencyId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Settlement.prototype.setCurrencyId = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SettlementRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SettlementRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SettlementRsp.displayName = 'proto.ctpfront.proto.SettlementRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SettlementRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SettlementRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SettlementRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SettlementRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Settlement.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SettlementRsp}
 */
proto.ctpfront.proto.SettlementRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SettlementRsp;
    return proto.ctpfront.proto.SettlementRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SettlementRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SettlementRsp}
 */
proto.ctpfront.proto.SettlementRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Settlement;
                reader.readMessage(value, proto.ctpfront.proto.Settlement.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SettlementRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SettlementRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SettlementRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SettlementRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.Settlement.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.SettlementRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.SettlementRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.SettlementRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SettlementRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Settlement data = 10;
 * @return {?proto.ctpfront.proto.Settlement}
 */
proto.ctpfront.proto.SettlementRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Settlement} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Settlement, 10));
};
/** @param {?proto.ctpfront.proto.Settlement|undefined} value */
proto.ctpfront.proto.SettlementRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.SettlementRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SettlementRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.PositionReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.PositionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.PositionReq.displayName = 'proto.ctpfront.proto.PositionReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.PositionReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.PositionReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.PositionReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            investUnitId: jspb.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionReq}
 */
proto.ctpfront.proto.PositionReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.PositionReq;
    return proto.ctpfront.proto.PositionReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionReq}
 */
proto.ctpfront.proto.PositionReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setInvestUnitId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.PositionReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.PositionReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.PositionReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getInvestUnitId();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.PositionReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.PositionReq.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionReq.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */
proto.ctpfront.proto.PositionReq.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionReq.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string invest_unit_id = 4;
 * @return {string}
 */
proto.ctpfront.proto.PositionReq.prototype.getInvestUnitId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionReq.prototype.setInvestUnitId = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Position = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Position, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Position.displayName = 'proto.ctpfront.proto.Position';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Position.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Position.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Position} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Position.toObject = function (includeInstance, msg) {
        var f, obj = {
            accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
            direction: +jspb.Message.getFieldWithDefault(msg, 4, 0.0),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            hedge: jspb.Message.getFieldWithDefault(msg, 6, 0),
            commission: +jspb.Message.getFieldWithDefault(msg, 7, 0.0),
            margin: +jspb.Message.getFieldWithDefault(msg, 8, 0.0),
            lastMargin: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
            cost: +jspb.Message.getFieldWithDefault(msg, 10, 0.0),
            amount: +jspb.Message.getFieldWithDefault(msg, 20, 0.0),
            todayVolume: jspb.Message.getFieldWithDefault(msg, 21, 0),
            lastVolume: jspb.Message.getFieldWithDefault(msg, 22, 0),
            frozenVolume: jspb.Message.getFieldWithDefault(msg, 23, 0),
            closeProfit: +jspb.Message.getFieldWithDefault(msg, 24, 0.0),
            positionProfit: +jspb.Message.getFieldWithDefault(msg, 25, 0.0),
            frozenCommission: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
            frozenMargin: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
            frozen: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 29, ""),
            settlementPrice: +jspb.Message.getFieldWithDefault(msg, 30, 0.0),
            lastSettlementPrice: +jspb.Message.getFieldWithDefault(msg, 40, 0.0),
            multiple: jspb.Message.getFieldWithDefault(msg, 41, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Position}
 */
proto.ctpfront.proto.Position.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Position;
    return proto.ctpfront.proto.Position.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Position} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Position}
 */
proto.ctpfront.proto.Position.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {number} */ (reader.readUint64());
                msg.setAccountId(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setDirection(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setHedge(value);
                break;
            case 7:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCommission(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setMargin(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLastMargin(value);
                break;
            case 10:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCost(value);
                break;
            case 20:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setAmount(value);
                break;
            case 21:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setTodayVolume(value);
                break;
            case 22:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setLastVolume(value);
                break;
            case 23:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setFrozenVolume(value);
                break;
            case 24:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCloseProfit(value);
                break;
            case 25:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPositionProfit(value);
                break;
            case 26:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozenCommission(value);
                break;
            case 27:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozenMargin(value);
                break;
            case 28:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setFrozen(value);
                break;
            case 29:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 30:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setSettlementPrice(value);
                break;
            case 40:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLastSettlementPrice(value);
                break;
            case 41:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setMultiple(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Position.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Position.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Position} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Position.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccountId();
    if (f !== 0) {
        writer.writeUint64(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getDirection();
    if (f !== 0.0) {
        writer.writeDouble(4, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getHedge();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
    f = message.getCommission();
    if (f !== 0.0) {
        writer.writeDouble(7, f);
    }
    f = message.getMargin();
    if (f !== 0.0) {
        writer.writeDouble(8, f);
    }
    f = message.getLastMargin();
    if (f !== 0.0) {
        writer.writeDouble(9, f);
    }
    f = message.getCost();
    if (f !== 0.0) {
        writer.writeDouble(10, f);
    }
    f = message.getAmount();
    if (f !== 0.0) {
        writer.writeDouble(20, f);
    }
    f = message.getTodayVolume();
    if (f !== 0) {
        writer.writeUint32(21, f);
    }
    f = message.getLastVolume();
    if (f !== 0) {
        writer.writeUint32(22, f);
    }
    f = message.getFrozenVolume();
    if (f !== 0) {
        writer.writeUint32(23, f);
    }
    f = message.getCloseProfit();
    if (f !== 0.0) {
        writer.writeDouble(24, f);
    }
    f = message.getPositionProfit();
    if (f !== 0.0) {
        writer.writeDouble(25, f);
    }
    f = message.getFrozenCommission();
    if (f !== 0.0) {
        writer.writeDouble(26, f);
    }
    f = message.getFrozenMargin();
    if (f !== 0.0) {
        writer.writeDouble(27, f);
    }
    f = message.getFrozen();
    if (f !== 0.0) {
        writer.writeDouble(28, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(29, f);
    }
    f = message.getSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(30, f);
    }
    f = message.getLastSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(40, f);
    }
    f = message.getMultiple();
    if (f !== 0) {
        writer.writeUint32(41, f);
    }
};
/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getAccountId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setAccountId = function (value) {
    jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.Position.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Position.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string target_id = 3;
 * @return {string}
 */
proto.ctpfront.proto.Position.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Position.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional double direction = 4;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getDirection = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 4, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setDirection = function (value) {
    jspb.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional uint32 exchange_id = 5;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint32 hedge = 6;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getHedge = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setHedge = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional double commission = 7;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getCommission = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 7, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setCommission = function (value) {
    jspb.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional double margin = 8;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 8, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional double last_margin = 9;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getLastMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setLastMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional double cost = 10;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getCost = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 10, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setCost = function (value) {
    jspb.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional double amount = 20;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getAmount = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 20, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setAmount = function (value) {
    jspb.Message.setProto3FloatField(this, 20, value);
};
/**
 * optional uint32 today_volume = 21;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getTodayVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setTodayVolume = function (value) {
    jspb.Message.setProto3IntField(this, 21, value);
};
/**
 * optional uint32 last_volume = 22;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getLastVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setLastVolume = function (value) {
    jspb.Message.setProto3IntField(this, 22, value);
};
/**
 * optional uint32 frozen_volume = 23;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getFrozenVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setFrozenVolume = function (value) {
    jspb.Message.setProto3IntField(this, 23, value);
};
/**
 * optional double close_profit = 24;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getCloseProfit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 24, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setCloseProfit = function (value) {
    jspb.Message.setProto3FloatField(this, 24, value);
};
/**
 * optional double position_profit = 25;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getPositionProfit = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 25, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setPositionProfit = function (value) {
    jspb.Message.setProto3FloatField(this, 25, value);
};
/**
 * optional double frozen_commission = 26;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getFrozenCommission = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 26, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setFrozenCommission = function (value) {
    jspb.Message.setProto3FloatField(this, 26, value);
};
/**
 * optional double frozen_margin = 27;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getFrozenMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 27, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setFrozenMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 27, value);
};
/**
 * optional double frozen = 28;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getFrozen = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 28, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setFrozen = function (value) {
    jspb.Message.setProto3FloatField(this, 28, value);
};
/**
 * optional string trading_day = 29;
 * @return {string}
 */
proto.ctpfront.proto.Position.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Position.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 29, value);
};
/**
 * optional double settlement_price = 30;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 30, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 30, value);
};
/**
 * optional double last_settlement_price = 40;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getLastSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 40, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setLastSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 40, value);
};
/**
 * optional uint32 multiple = 41;
 * @return {number}
 */
proto.ctpfront.proto.Position.prototype.getMultiple = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Position.prototype.setMultiple = function (value) {
    jspb.Message.setProto3IntField(this, 41, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.PositionRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.PositionRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.PositionRsp.displayName = 'proto.ctpfront.proto.PositionRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.PositionRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.PositionRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.PositionRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Position.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionRsp}
 */
proto.ctpfront.proto.PositionRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.PositionRsp;
    return proto.ctpfront.proto.PositionRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionRsp}
 */
proto.ctpfront.proto.PositionRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Position;
                reader.readMessage(value, proto.ctpfront.proto.Position.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.PositionRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.PositionRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.PositionRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.Position.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.PositionRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.PositionRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.PositionRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.PositionRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Position data = 10;
 * @return {?proto.ctpfront.proto.Position}
 */
proto.ctpfront.proto.PositionRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Position} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Position, 10));
};
/** @param {?proto.ctpfront.proto.Position|undefined} value */
proto.ctpfront.proto.PositionRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.PositionRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.PositionRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.PositionDetailReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.PositionDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.PositionDetailReq.displayName = 'proto.ctpfront.proto.PositionDetailReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.PositionDetailReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.PositionDetailReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetailReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.PositionDetailReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            investUnitId: jspb.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetailReq}
 */
proto.ctpfront.proto.PositionDetailReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.PositionDetailReq;
    return proto.ctpfront.proto.PositionDetailReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetailReq}
 */
proto.ctpfront.proto.PositionDetailReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setInvestUnitId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.PositionDetailReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.PositionDetailReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.PositionDetailReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getInvestUnitId();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetailReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetailReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetailReq.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetailReq.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetailReq.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetailReq.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string invest_unit_id = 4;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetailReq.prototype.getInvestUnitId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetailReq.prototype.setInvestUnitId = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.PositionDetail = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.PositionDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.PositionDetail.displayName = 'proto.ctpfront.proto.PositionDetail';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.PositionDetail.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.PositionDetail.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetail} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.PositionDetail.toObject = function (includeInstance, msg) {
        var f, obj = {
            account: jspb.Message.getFieldWithDefault(msg, 1, ""),
            closeAmount: +jspb.Message.getFieldWithDefault(msg, 4, 0.0),
            closeProfitByDate: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
            closeProfitByTrade: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
            direction: jspb.Message.getFieldWithDefault(msg, 8, 0),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 9, 0),
            hedge: jspb.Message.getFieldWithDefault(msg, 10, 0),
            targetId: jspb.Message.getFieldWithDefault(msg, 11, ""),
            marginRateByMoney: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
            marginRateByVolume: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
            positionProfitByDate: +jspb.Message.getFieldWithDefault(msg, 17, 0.0),
            positionProfitByTrade: +jspb.Message.getFieldWithDefault(msg, 18, 0.0),
            lastSettlementPrice: +jspb.Message.getFieldWithDefault(msg, 19, 0.0),
            settlementPrice: +jspb.Message.getFieldWithDefault(msg, 20, 0.0),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 21, ""),
            openPrice: +jspb.Message.getFieldWithDefault(msg, 22, 0.0),
            openDate: jspb.Message.getFieldWithDefault(msg, 24, ""),
            volume: jspb.Message.getFieldWithDefault(msg, 27, 0),
            closeVolume: jspb.Message.getFieldWithDefault(msg, 28, 0),
            margin: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
            exchmargin: +jspb.Message.getFieldWithDefault(msg, 30, 0.0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetail}
 */
proto.ctpfront.proto.PositionDetail.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.PositionDetail;
    return proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetail}
 */
proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCloseAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCloseProfitByDate(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setCloseProfitByTrade(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setDirection(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setExchangeId(value);
                break;
            case 10:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setHedge(value);
                break;
            case 11:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 12:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setMarginRateByMoney(value);
                break;
            case 13:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setMarginRateByVolume(value);
                break;
            case 17:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPositionProfitByDate(value);
                break;
            case 18:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPositionProfitByTrade(value);
                break;
            case 19:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLastSettlementPrice(value);
                break;
            case 20:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setSettlementPrice(value);
                break;
            case 21:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 22:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setOpenPrice(value);
                break;
            case 24:
                var value = /** @type {string} */ (reader.readString());
                msg.setOpenDate(value);
                break;
            case 27:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setVolume(value);
                break;
            case 28:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setCloseVolume(value);
                break;
            case 29:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setMargin(value);
                break;
            case 30:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setExchmargin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.PositionDetail.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getCloseAmount();
    if (f !== 0.0) {
        writer.writeDouble(4, f);
    }
    f = message.getCloseProfitByDate();
    if (f !== 0.0) {
        writer.writeDouble(5, f);
    }
    f = message.getCloseProfitByTrade();
    if (f !== 0.0) {
        writer.writeDouble(6, f);
    }
    f = message.getDirection();
    if (f !== 0) {
        writer.writeInt32(8, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeInt32(9, f);
    }
    f = message.getHedge();
    if (f !== 0) {
        writer.writeInt32(10, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(11, f);
    }
    f = message.getMarginRateByMoney();
    if (f !== 0.0) {
        writer.writeDouble(12, f);
    }
    f = message.getMarginRateByVolume();
    if (f !== 0.0) {
        writer.writeDouble(13, f);
    }
    f = message.getPositionProfitByDate();
    if (f !== 0.0) {
        writer.writeDouble(17, f);
    }
    f = message.getPositionProfitByTrade();
    if (f !== 0.0) {
        writer.writeDouble(18, f);
    }
    f = message.getLastSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(19, f);
    }
    f = message.getSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(20, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(21, f);
    }
    f = message.getOpenPrice();
    if (f !== 0.0) {
        writer.writeDouble(22, f);
    }
    f = message.getOpenDate();
    if (f.length > 0) {
        writer.writeString(24, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeInt32(27, f);
    }
    f = message.getCloseVolume();
    if (f !== 0) {
        writer.writeInt32(28, f);
    }
    f = message.getMargin();
    if (f !== 0.0) {
        writer.writeDouble(29, f);
    }
    f = message.getExchmargin();
    if (f !== 0.0) {
        writer.writeDouble(30, f);
    }
};
/**
 * optional string account = 1;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetail.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetail.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional double close_amount = 4;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getCloseAmount = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 4, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setCloseAmount = function (value) {
    jspb.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional double close_profit_by_date = 5;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getCloseProfitByDate = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setCloseProfitByDate = function (value) {
    jspb.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional double close_profit_by_trade = 6;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getCloseProfitByTrade = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setCloseProfitByTrade = function (value) {
    jspb.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional int32 direction = 8;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setDirection = function (value) {
    jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 exchange_id = 9;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 hedge = 10;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getHedge = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setHedge = function (value) {
    jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional string target_id = 11;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetail.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetail.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * optional double margin_rate_by_money = 12;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getMarginRateByMoney = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 12, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setMarginRateByMoney = function (value) {
    jspb.Message.setProto3FloatField(this, 12, value);
};
/**
 * optional double margin_rate_by_volume = 13;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getMarginRateByVolume = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 13, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setMarginRateByVolume = function (value) {
    jspb.Message.setProto3FloatField(this, 13, value);
};
/**
 * optional double position_profit_by_date = 17;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getPositionProfitByDate = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 17, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setPositionProfitByDate = function (value) {
    jspb.Message.setProto3FloatField(this, 17, value);
};
/**
 * optional double position_profit_by_trade = 18;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getPositionProfitByTrade = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 18, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setPositionProfitByTrade = function (value) {
    jspb.Message.setProto3FloatField(this, 18, value);
};
/**
 * optional double last_settlement_price = 19;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getLastSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 19, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setLastSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 19, value);
};
/**
 * optional double settlement_price = 20;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 20, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 20, value);
};
/**
 * optional string trading_day = 21;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetail.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetail.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 21, value);
};
/**
 * optional double open_price = 22;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getOpenPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 22, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setOpenPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 22, value);
};
/**
 * optional string open_date = 24;
 * @return {string}
 */
proto.ctpfront.proto.PositionDetail.prototype.getOpenDate = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};
/** @param {string} value */
proto.ctpfront.proto.PositionDetail.prototype.setOpenDate = function (value) {
    jspb.Message.setProto3StringField(this, 24, value);
};
/**
 * optional int32 volume = 27;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 27, value);
};
/**
 * optional int32 close_volume = 28;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getCloseVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setCloseVolume = function (value) {
    jspb.Message.setProto3IntField(this, 28, value);
};
/**
 * optional double margin = 29;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getMargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 29, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setMargin = function (value) {
    jspb.Message.setProto3FloatField(this, 29, value);
};
/**
 * optional double exchmargin = 30;
 * @return {number}
 */
proto.ctpfront.proto.PositionDetail.prototype.getExchmargin = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 30, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.PositionDetail.prototype.setExchmargin = function (value) {
    jspb.Message.setProto3FloatField(this, 30, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.PositionDetailRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.PositionDetailRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.PositionDetailRsp.displayName = 'proto.ctpfront.proto.PositionDetailRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.PositionDetailRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.PositionDetailRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetailRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.PositionDetailRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.PositionDetail.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetailRsp}
 */
proto.ctpfront.proto.PositionDetailRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.PositionDetailRsp;
    return proto.ctpfront.proto.PositionDetailRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetailRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetailRsp}
 */
proto.ctpfront.proto.PositionDetailRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.PositionDetail;
                reader.readMessage(value, proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.PositionDetailRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.PositionDetailRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetailRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.PositionDetailRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.PositionDetailRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.PositionDetailRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.PositionDetailRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.PositionDetailRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional PositionDetail data = 10;
 * @return {?proto.ctpfront.proto.PositionDetail}
 */
proto.ctpfront.proto.PositionDetailRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.PositionDetail} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.PositionDetail, 10));
};
/** @param {?proto.ctpfront.proto.PositionDetail|undefined} value */
proto.ctpfront.proto.PositionDetailRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.PositionDetailRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.PositionDetailRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Quote = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Quote, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Quote.displayName = 'proto.ctpfront.proto.Quote';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Quote.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Quote.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Quote} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Quote.toObject = function (includeInstance, msg) {
        var f, obj = {
            askPrice1: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
            askVolume1: jspb.Message.getFieldWithDefault(msg, 6, 0),
            averagePrice: +jspb.Message.getFieldWithDefault(msg, 11, 0.0),
            bidPrice1: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
            bidVolume1: jspb.Message.getFieldWithDefault(msg, 17, 0),
            closePrice: +jspb.Message.getFieldWithDefault(msg, 22, 0.0),
            targetId: jspb.Message.getFieldWithDefault(msg, 23, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 24, 0),
            lowPrice: +jspb.Message.getFieldWithDefault(msg, 25, 0.0),
            highPrice: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
            latestPrice: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
            lowStopPrice: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
            highStopPrice: +jspb.Message.getFieldWithDefault(msg, 30, 0.0),
            openPrice: +jspb.Message.getFieldWithDefault(msg, 32, 0.0),
            lastClosePrice: +jspb.Message.getFieldWithDefault(msg, 33, 0.0),
            lastSettlementPrice: +jspb.Message.getFieldWithDefault(msg, 36, 0.0),
            settlementPrice: +jspb.Message.getFieldWithDefault(msg, 37, 0.0),
            tradingDay: jspb.Message.getFieldWithDefault(msg, 38, ""),
            turnover: +jspb.Message.getFieldWithDefault(msg, 39, 0.0),
            updateMill: jspb.Message.getFieldWithDefault(msg, 40, 0),
            updateTime: jspb.Message.getFieldWithDefault(msg, 41, ""),
            volume: jspb.Message.getFieldWithDefault(msg, 43, 0),
            priceTick: +jspb.Message.getFieldWithDefault(msg, 44, 0.0),
            position: jspb.Message.getFieldWithDefault(msg, 45, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Quote}
 */
proto.ctpfront.proto.Quote.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Quote;
    return proto.ctpfront.proto.Quote.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Quote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Quote}
 */
proto.ctpfront.proto.Quote.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setAskPrice1(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setAskVolume1(value);
                break;
            case 11:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setAveragePrice(value);
                break;
            case 12:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setBidPrice1(value);
                break;
            case 17:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setBidVolume1(value);
                break;
            case 22:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setClosePrice(value);
                break;
            case 23:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 24:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setExchangeId(value);
                break;
            case 25:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLowPrice(value);
                break;
            case 26:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setHighPrice(value);
                break;
            case 28:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLatestPrice(value);
                break;
            case 29:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLowStopPrice(value);
                break;
            case 30:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setHighStopPrice(value);
                break;
            case 32:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setOpenPrice(value);
                break;
            case 33:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLastClosePrice(value);
                break;
            case 36:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setLastSettlementPrice(value);
                break;
            case 37:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setSettlementPrice(value);
                break;
            case 38:
                var value = /** @type {string} */ (reader.readString());
                msg.setTradingDay(value);
                break;
            case 39:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setTurnover(value);
                break;
            case 40:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setUpdateMill(value);
                break;
            case 41:
                var value = /** @type {string} */ (reader.readString());
                msg.setUpdateTime(value);
                break;
            case 43:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setVolume(value);
                break;
            case 44:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPriceTick(value);
                break;
            case 45:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setPosition(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Quote.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Quote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Quote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Quote.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getAskPrice1();
    if (f !== 0.0) {
        writer.writeDouble(1, f);
    }
    f = message.getAskVolume1();
    if (f !== 0) {
        writer.writeInt32(6, f);
    }
    f = message.getAveragePrice();
    if (f !== 0.0) {
        writer.writeDouble(11, f);
    }
    f = message.getBidPrice1();
    if (f !== 0.0) {
        writer.writeDouble(12, f);
    }
    f = message.getBidVolume1();
    if (f !== 0) {
        writer.writeInt32(17, f);
    }
    f = message.getClosePrice();
    if (f !== 0.0) {
        writer.writeDouble(22, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(23, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeInt32(24, f);
    }
    f = message.getLowPrice();
    if (f !== 0.0) {
        writer.writeDouble(25, f);
    }
    f = message.getHighPrice();
    if (f !== 0.0) {
        writer.writeDouble(26, f);
    }
    f = message.getLatestPrice();
    if (f !== 0.0) {
        writer.writeDouble(28, f);
    }
    f = message.getLowStopPrice();
    if (f !== 0.0) {
        writer.writeDouble(29, f);
    }
    f = message.getHighStopPrice();
    if (f !== 0.0) {
        writer.writeDouble(30, f);
    }
    f = message.getOpenPrice();
    if (f !== 0.0) {
        writer.writeDouble(32, f);
    }
    f = message.getLastClosePrice();
    if (f !== 0.0) {
        writer.writeDouble(33, f);
    }
    f = message.getLastSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(36, f);
    }
    f = message.getSettlementPrice();
    if (f !== 0.0) {
        writer.writeDouble(37, f);
    }
    f = message.getTradingDay();
    if (f.length > 0) {
        writer.writeString(38, f);
    }
    f = message.getTurnover();
    if (f !== 0.0) {
        writer.writeDouble(39, f);
    }
    f = message.getUpdateMill();
    if (f !== 0) {
        writer.writeInt32(40, f);
    }
    f = message.getUpdateTime();
    if (f.length > 0) {
        writer.writeString(41, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeInt32(43, f);
    }
    f = message.getPriceTick();
    if (f !== 0.0) {
        writer.writeDouble(44, f);
    }
    f = message.getPosition();
    if (f !== 0) {
        writer.writeInt32(45, f);
    }
};
/**
 * optional double ask_price1 = 1;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getAskPrice1 = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setAskPrice1 = function (value) {
    jspb.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional int32 ask_volume1 = 6;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getAskVolume1 = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setAskVolume1 = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional double average_price = 11;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getAveragePrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 11, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setAveragePrice = function (value) {
    jspb.Message.setProto3FloatField(this, 11, value);
};
/**
 * optional double bid_price1 = 12;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getBidPrice1 = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 12, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setBidPrice1 = function (value) {
    jspb.Message.setProto3FloatField(this, 12, value);
};
/**
 * optional int32 bid_volume1 = 17;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getBidVolume1 = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setBidVolume1 = function (value) {
    jspb.Message.setProto3IntField(this, 17, value);
};
/**
 * optional double close_price = 22;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getClosePrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 22, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setClosePrice = function (value) {
    jspb.Message.setProto3FloatField(this, 22, value);
};
/**
 * optional string target_id = 23;
 * @return {string}
 */
proto.ctpfront.proto.Quote.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Quote.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 23, value);
};
/**
 * optional int32 exchange_id = 24;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 24, value);
};
/**
 * optional double low_price = 25;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getLowPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 25, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setLowPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 25, value);
};
/**
 * optional double high_price = 26;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getHighPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 26, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setHighPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 26, value);
};
/**
 * optional double latest_price = 28;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getLatestPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 28, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setLatestPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 28, value);
};
/**
 * optional double low_stop_price = 29;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getLowStopPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 29, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setLowStopPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 29, value);
};
/**
 * optional double high_stop_price = 30;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getHighStopPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 30, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setHighStopPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 30, value);
};
/**
 * optional double open_price = 32;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getOpenPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 32, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setOpenPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 32, value);
};
/**
 * optional double last_close_price = 33;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getLastClosePrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 33, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setLastClosePrice = function (value) {
    jspb.Message.setProto3FloatField(this, 33, value);
};
/**
 * optional double last_settlement_price = 36;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getLastSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 36, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setLastSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 36, value);
};
/**
 * optional double settlement_price = 37;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getSettlementPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 37, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setSettlementPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 37, value);
};
/**
 * optional string trading_day = 38;
 * @return {string}
 */
proto.ctpfront.proto.Quote.prototype.getTradingDay = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Quote.prototype.setTradingDay = function (value) {
    jspb.Message.setProto3StringField(this, 38, value);
};
/**
 * optional double turnover = 39;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getTurnover = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 39, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setTurnover = function (value) {
    jspb.Message.setProto3FloatField(this, 39, value);
};
/**
 * optional int32 update_mill = 40;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getUpdateMill = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setUpdateMill = function (value) {
    jspb.Message.setProto3IntField(this, 40, value);
};
/**
 * optional string update_time = 41;
 * @return {string}
 */
proto.ctpfront.proto.Quote.prototype.getUpdateTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Quote.prototype.setUpdateTime = function (value) {
    jspb.Message.setProto3StringField(this, 41, value);
};
/**
 * optional int32 volume = 43;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 43, value);
};
/**
 * optional double price_tick = 44;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getPriceTick = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 44, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setPriceTick = function (value) {
    jspb.Message.setProto3FloatField(this, 44, value);
};
/**
 * optional int32 position = 45;
 * @return {number}
 */
proto.ctpfront.proto.Quote.prototype.getPosition = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Quote.prototype.setPosition = function (value) {
    jspb.Message.setProto3IntField(this, 45, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.QuoteReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.QuoteReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.QuoteReq.displayName = 'proto.ctpfront.proto.QuoteReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.QuoteReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.QuoteReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.QuoteReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.QuoteReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            targetId: jspb.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.QuoteReq}
 */
proto.ctpfront.proto.QuoteReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.QuoteReq;
    return proto.ctpfront.proto.QuoteReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.QuoteReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.QuoteReq}
 */
proto.ctpfront.proto.QuoteReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.QuoteReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.QuoteReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.QuoteReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.QuoteReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
};
/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.ctpfront.proto.QuoteReq.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.QuoteReq.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.QuoteRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.QuoteRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.QuoteRsp.displayName = 'proto.ctpfront.proto.QuoteRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.QuoteRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.QuoteRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.QuoteRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.QuoteRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Quote.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.QuoteRsp}
 */
proto.ctpfront.proto.QuoteRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.QuoteRsp;
    return proto.ctpfront.proto.QuoteRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.QuoteRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.QuoteRsp}
 */
proto.ctpfront.proto.QuoteRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Quote;
                reader.readMessage(value, proto.ctpfront.proto.Quote.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.QuoteRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.QuoteRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.QuoteRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.QuoteRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.Quote.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.QuoteRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.QuoteRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.QuoteRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.QuoteRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Quote data = 10;
 * @return {?proto.ctpfront.proto.Quote}
 */
proto.ctpfront.proto.QuoteRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Quote} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Quote, 10));
};
/** @param {?proto.ctpfront.proto.Quote|undefined} value */
proto.ctpfront.proto.QuoteRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.QuoteRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.QuoteRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TargetReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TargetReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TargetReq.displayName = 'proto.ctpfront.proto.TargetReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TargetReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TargetReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TargetReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            targetId: jspb.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetReq}
 */
proto.ctpfront.proto.TargetReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TargetReq;
    return proto.ctpfront.proto.TargetReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetReq}
 */
proto.ctpfront.proto.TargetReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TargetReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TargetReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TargetReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
};
/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.ctpfront.proto.TargetReq.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetReq.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Target = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Target, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Target.displayName = 'proto.ctpfront.proto.Target';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Target.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Target.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Target} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Target.toObject = function (includeInstance, msg) {
        var f, obj = {
            targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetName: jspb.Message.getFieldWithDefault(msg, 2, ""),
            productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            productName: jspb.Message.getFieldWithDefault(msg, 5, ""),
            exchangeName: jspb.Message.getFieldWithDefault(msg, 6, ""),
            multiple: jspb.Message.getFieldWithDefault(msg, 7, 0),
            priceTick: +jspb.Message.getFieldWithDefault(msg, 8, 0.0),
            productClass: jspb.Message.getFieldWithDefault(msg, 9, 0),
            targetCode: jspb.Message.getFieldWithDefault(msg, 10, ""),
            deliveryMonth: jspb.Message.getFieldWithDefault(msg, 11, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Target}
 */
proto.ctpfront.proto.Target.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Target;
    return proto.ctpfront.proto.Target.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Target} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Target}
 */
proto.ctpfront.proto.Target.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetName(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setProductId(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setProductName(value);
                break;
            case 6:
                var value = /** @type {string} */ (reader.readString());
                msg.setExchangeName(value);
                break;
            case 7:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setMultiple(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPriceTick(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setProductClass(value);
                break;
            case 10:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetCode(value);
                break;
            case 11:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setDeliveryMonth(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Target.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Target.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Target} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Target.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetName();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getProductId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getProductName();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
    f = message.getExchangeName();
    if (f.length > 0) {
        writer.writeString(6, f);
    }
    f = message.getMultiple();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
    f = message.getPriceTick();
    if (f !== 0.0) {
        writer.writeDouble(8, f);
    }
    f = message.getProductClass();
    if (f !== 0) {
        writer.writeUint32(9, f);
    }
    f = message.getTargetCode();
    if (f.length > 0) {
        writer.writeString(10, f);
    }
    f = message.getDeliveryMonth();
    if (f !== 0) {
        writer.writeUint32(11, f);
    }
};
/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_name = 2;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getTargetName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setTargetName = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getProductId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setProductId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint32 exchange_id = 4;
 * @return {number}
 */
proto.ctpfront.proto.Target.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Target.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string product_name = 5;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getProductName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setProductName = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string exchange_name = 6;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getExchangeName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setExchangeName = function (value) {
    jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional uint32 multiple = 7;
 * @return {number}
 */
proto.ctpfront.proto.Target.prototype.getMultiple = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Target.prototype.setMultiple = function (value) {
    jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional double price_tick = 8;
 * @return {number}
 */
proto.ctpfront.proto.Target.prototype.getPriceTick = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 8, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.Target.prototype.setPriceTick = function (value) {
    jspb.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional uint32 product_class = 9;
 * @return {number}
 */
proto.ctpfront.proto.Target.prototype.getProductClass = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Target.prototype.setProductClass = function (value) {
    jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional string target_code = 10;
 * @return {string}
 */
proto.ctpfront.proto.Target.prototype.getTargetCode = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Target.prototype.setTargetCode = function (value) {
    jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional uint32 delivery_month = 11;
 * @return {number}
 */
proto.ctpfront.proto.Target.prototype.getDeliveryMonth = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Target.prototype.setDeliveryMonth = function (value) {
    jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TargetRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.ctpfront.proto.TargetRsp.repeatedFields_, null);
};
goog.inherits(proto.ctpfront.proto.TargetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TargetRsp.displayName = 'proto.ctpfront.proto.TargetRsp';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ctpfront.proto.TargetRsp.repeatedFields_ = [10];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TargetRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TargetRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TargetRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            dataList: jspb.Message.toObjectList(msg.getDataList(), proto.ctpfront.proto.Target.toObject, includeInstance)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetRsp}
 */
proto.ctpfront.proto.TargetRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TargetRsp;
    return proto.ctpfront.proto.TargetRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetRsp}
 */
proto.ctpfront.proto.TargetRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.Target;
                reader.readMessage(value, proto.ctpfront.proto.Target.deserializeBinaryFromReader);
                msg.addData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TargetRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TargetRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TargetRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getDataList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(10, f, proto.ctpfront.proto.Target.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.TargetRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.TargetRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.TargetRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.TargetRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * repeated Target data = 10;
 * @return {!Array.<!proto.ctpfront.proto.Target>}
 */
proto.ctpfront.proto.TargetRsp.prototype.getDataList = function () {
    return /** @type{!Array.<!proto.ctpfront.proto.Target>} */ (jspb.Message.getRepeatedWrapperField(this, proto.ctpfront.proto.Target, 10));
};
/** @param {!Array.<!proto.ctpfront.proto.Target>} value */
proto.ctpfront.proto.TargetRsp.prototype.setDataList = function (value) {
    jspb.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.ctpfront.proto.Target=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ctpfront.proto.Target}
 */
proto.ctpfront.proto.TargetRsp.prototype.addData = function (opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.ctpfront.proto.Target, opt_index);
};
proto.ctpfront.proto.TargetRsp.prototype.clearDataList = function () {
    this.setDataList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubTickReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.ctpfront.proto.SubTickReq.repeatedFields_, null);
};
goog.inherits(proto.ctpfront.proto.SubTickReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubTickReq.displayName = 'proto.ctpfront.proto.SubTickReq';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ctpfront.proto.SubTickReq.repeatedFields_ = [1];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubTickReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubTickReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubTickReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubTickReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            targetList: jspb.Message.getRepeatedField(msg, 1)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubTickReq}
 */
proto.ctpfront.proto.SubTickReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubTickReq;
    return proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubTickReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubTickReq}
 */
proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.addTarget(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubTickReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubTickReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getTargetList();
    if (f.length > 0) {
        writer.writeRepeatedString(1, f);
    }
};
/**
 * repeated string target = 1;
 * @return {!Array.<string>}
 */
proto.ctpfront.proto.SubTickReq.prototype.getTargetList = function () {
    return /** @type {!Array.<string>} */ (jspb.Message.getRepeatedField(this, 1));
};
/** @param {!Array.<string>} value */
proto.ctpfront.proto.SubTickReq.prototype.setTargetList = function (value) {
    jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.ctpfront.proto.SubTickReq.prototype.addTarget = function (value, opt_index) {
    jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
proto.ctpfront.proto.SubTickReq.prototype.clearTargetList = function () {
    this.setTargetList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubTickRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SubTickRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubTickRsp.displayName = 'proto.ctpfront.proto.SubTickRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubTickRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubTickRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubTickRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubTickRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.SubTickReq.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubTickRsp}
 */
proto.ctpfront.proto.SubTickRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubTickRsp;
    return proto.ctpfront.proto.SubTickRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubTickRsp}
 */
proto.ctpfront.proto.SubTickRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 10:
                var value = new proto.ctpfront.proto.SubTickReq;
                reader.readMessage(value, proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubTickRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubTickRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubTickRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(10, f, proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.SubTickRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.SubTickRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.SubTickRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SubTickRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional SubTickReq data = 10;
 * @return {?proto.ctpfront.proto.SubTickReq}
 */
proto.ctpfront.proto.SubTickRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.SubTickReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.SubTickReq, 10));
};
/** @param {?proto.ctpfront.proto.SubTickReq|undefined} value */
proto.ctpfront.proto.SubTickRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 10, value);
};
proto.ctpfront.proto.SubTickRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SubTickRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Subscribe = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Subscribe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Subscribe.displayName = 'proto.ctpfront.proto.Subscribe';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Subscribe.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Subscribe.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Subscribe} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Subscribe.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Subscribe}
 */
proto.ctpfront.proto.Subscribe.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Subscribe;
    return proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Subscribe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Subscribe}
 */
proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Subscribe.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Subscribe.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Subscribe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Subscribe.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.Subscribe.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Subscribe.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.Subscribe.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Subscribe.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Response = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Response.displayName = 'proto.ctpfront.proto.Response';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Response.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Response.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Response} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Response.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.Subscribe.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Response}
 */
proto.ctpfront.proto.Response.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Response;
    return proto.ctpfront.proto.Response.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Response}
 */
proto.ctpfront.proto.Response.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.Subscribe;
                reader.readMessage(value, proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Response.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Response.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Response.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.Subscribe.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.Response.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.Response.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.Response.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.Response.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Subscribe data = 2;
 * @return {?proto.ctpfront.proto.Subscribe}
 */
proto.ctpfront.proto.Response.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.Subscribe} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Subscribe, 2));
};
/** @param {?proto.ctpfront.proto.Subscribe|undefined} value */
proto.ctpfront.proto.Response.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.Response.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.Response.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TargetSelected = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TargetSelected, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TargetSelected.displayName = 'proto.ctpfront.proto.TargetSelected';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TargetSelected.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TargetSelected.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelected} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TargetSelected.toObject = function (includeInstance, msg) {
        var f, obj = {
            targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
            broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
            account: jspb.Message.getFieldWithDefault(msg, 4, ""),
            stamp: jspb.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelected}
 */
proto.ctpfront.proto.TargetSelected.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TargetSelected;
    return proto.ctpfront.proto.TargetSelected.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelected}
 */
proto.ctpfront.proto.TargetSelected.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setStamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TargetSelected.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TargetSelected.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TargetSelected.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getStamp();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
};
/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelected.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelected.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string broker = 3;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelected.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelected.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string account = 4;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelected.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelected.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint32 stamp = 5;
 * @return {number}
 */
proto.ctpfront.proto.TargetSelected.prototype.getStamp = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};
/** @param {number} value */
proto.ctpfront.proto.TargetSelected.prototype.setStamp = function (value) {
    jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TargetSelectedReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TargetSelectedReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TargetSelectedReq.displayName = 'proto.ctpfront.proto.TargetSelectedReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TargetSelectedReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TargetSelectedReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelectedReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TargetSelectedReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelectedReq}
 */
proto.ctpfront.proto.TargetSelectedReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TargetSelectedReq;
    return proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelectedReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelectedReq}
 */
proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TargetSelectedReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelectedReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelectedReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelectedReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelectedReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelectedReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string target_id = 3;
 * @return {string}
 */
proto.ctpfront.proto.TargetSelectedReq.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TargetSelectedReq.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TargetSelectedRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TargetSelectedRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TargetSelectedRsp.displayName = 'proto.ctpfront.proto.TargetSelectedRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TargetSelectedRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TargetSelectedRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelectedRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TargetSelectedRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.TargetSelectedReq.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelectedRsp}
 */
proto.ctpfront.proto.TargetSelectedRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TargetSelectedRsp;
    return proto.ctpfront.proto.TargetSelectedRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelectedRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelectedRsp}
 */
proto.ctpfront.proto.TargetSelectedRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.TargetSelectedReq;
                reader.readMessage(value, proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TargetSelectedRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TargetSelectedRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelectedRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TargetSelectedRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.TargetSelectedRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.TargetSelectedRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.TargetSelectedRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.TargetSelectedRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional TargetSelectedReq data = 2;
 * @return {?proto.ctpfront.proto.TargetSelectedReq}
 */
proto.ctpfront.proto.TargetSelectedRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.TargetSelectedReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.TargetSelectedReq, 2));
};
/** @param {?proto.ctpfront.proto.TargetSelectedReq|undefined} value */
proto.ctpfront.proto.TargetSelectedRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.TargetSelectedRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.TargetSelectedRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Dominant = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Dominant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Dominant.displayName = 'proto.ctpfront.proto.Dominant';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Dominant.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Dominant.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Dominant} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Dominant.toObject = function (includeInstance, msg) {
        var f, obj = {
            productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            exchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            volume: jspb.Message.getFieldWithDefault(msg, 4, 0),
            position: jspb.Message.getFieldWithDefault(msg, 5, 0),
            productName: jspb.Message.getFieldWithDefault(msg, 6, ""),
            exchangeName: jspb.Message.getFieldWithDefault(msg, 7, ""),
            stamp: jspb.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Dominant}
 */
proto.ctpfront.proto.Dominant.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Dominant;
    return proto.ctpfront.proto.Dominant.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Dominant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Dominant}
 */
proto.ctpfront.proto.Dominant.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setProductId(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setExchangeId(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setVolume(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setPosition(value);
                break;
            case 6:
                var value = /** @type {string} */ (reader.readString());
                msg.setProductName(value);
                break;
            case 7:
                var value = /** @type {string} */ (reader.readString());
                msg.setExchangeName(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setStamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Dominant.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Dominant.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Dominant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Dominant.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getProductId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getExchangeId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getPosition();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getProductName();
    if (f.length > 0) {
        writer.writeString(6, f);
    }
    f = message.getExchangeName();
    if (f.length > 0) {
        writer.writeString(7, f);
    }
    f = message.getStamp();
    if (f !== 0) {
        writer.writeUint32(8, f);
    }
};
/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.ctpfront.proto.Dominant.prototype.getProductId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Dominant.prototype.setProductId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.Dominant.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Dominant.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */
proto.ctpfront.proto.Dominant.prototype.getExchangeId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Dominant.prototype.setExchangeId = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional uint32 volume = 4;
 * @return {number}
 */
proto.ctpfront.proto.Dominant.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Dominant.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint32 position = 5;
 * @return {number}
 */
proto.ctpfront.proto.Dominant.prototype.getPosition = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Dominant.prototype.setPosition = function (value) {
    jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string product_name = 6;
 * @return {string}
 */
proto.ctpfront.proto.Dominant.prototype.getProductName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Dominant.prototype.setProductName = function (value) {
    jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string exchange_name = 7;
 * @return {string}
 */
proto.ctpfront.proto.Dominant.prototype.getExchangeName = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Dominant.prototype.setExchangeName = function (value) {
    jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional uint32 stamp = 8;
 * @return {number}
 */
proto.ctpfront.proto.Dominant.prototype.getStamp = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};
/** @param {number} value */
proto.ctpfront.proto.Dominant.prototype.setStamp = function (value) {
    jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.OrderConditional = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.OrderConditional, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.OrderConditional.displayName = 'proto.ctpfront.proto.OrderConditional';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.OrderConditional.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.OrderConditional.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditional} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.OrderConditional.toObject = function (includeInstance, msg) {
        var f, obj = {
            id: jspb.Message.getFieldWithDefault(msg, 1, ""),
            targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            insertDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
            insertTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
            price: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
            conditionPriceType: jspb.Message.getFieldWithDefault(msg, 6, 0),
            volume: jspb.Message.getFieldWithDefault(msg, 7, 0),
            direction: jspb.Message.getFieldWithDefault(msg, 8, 0),
            offset: jspb.Message.getFieldWithDefault(msg, 9, 0),
            validTime: jspb.Message.getFieldWithDefault(msg, 10, 0),
            state: jspb.Message.getFieldWithDefault(msg, 11, 0),
            stateDetail: jspb.Message.getFieldWithDefault(msg, 12, ""),
            broker: jspb.Message.getFieldWithDefault(msg, 20, ""),
            account: jspb.Message.getFieldWithDefault(msg, 21, ""),
            stamp: jspb.Message.getFieldWithDefault(msg, 22, 0),
            operationType: jspb.Message.getFieldWithDefault(msg, 23, 0),
            orderPriceType: jspb.Message.getFieldWithDefault(msg, 24, 0),
            orderPrice: +jspb.Message.getFieldWithDefault(msg, 25, 0.0),
            orderType: jspb.Message.getFieldWithDefault(msg, 27, 0),
            slPrice: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
            tpPrice: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
            posDirection: jspb.Message.getFieldWithDefault(msg, 30, 0),
            updateDate: jspb.Message.getFieldWithDefault(msg, 31, ""),
            updateTime: jspb.Message.getFieldWithDefault(msg, 32, ""),
            priceTypeMarket: jspb.Message.getFieldWithDefault(msg, 33, false)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditional}
 */
proto.ctpfront.proto.OrderConditional.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.OrderConditional;
    return proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditional} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditional}
 */
proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTargetId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setInsertDate(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setInsertTime(value);
                break;
            case 5:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setPrice(value);
                break;
            case 6:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setConditionPriceType(value);
                break;
            case 7:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setVolume(value);
                break;
            case 8:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setDirection(value);
                break;
            case 9:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOffset(value);
                break;
            case 10:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setValidTime(value);
                break;
            case 11:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setState(value);
                break;
            case 12:
                var value = /** @type {string} */ (reader.readString());
                msg.setStateDetail(value);
                break;
            case 20:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 21:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 22:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setStamp(value);
                break;
            case 23:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOperationType(value);
                break;
            case 24:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOrderPriceType(value);
                break;
            case 25:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setOrderPrice(value);
                break;
            case 27:
                var value = /** @type {number} */ (reader.readUint32());
                msg.setOrderType(value);
                break;
            case 28:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setSlPrice(value);
                break;
            case 29:
                var value = /** @type {number} */ (reader.readDouble());
                msg.setTpPrice(value);
                break;
            case 30:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setPosDirection(value);
                break;
            case 31:
                var value = /** @type {string} */ (reader.readString());
                msg.setUpdateDate(value);
                break;
            case 32:
                var value = /** @type {string} */ (reader.readString());
                msg.setUpdateTime(value);
                break;
            case 33:
                var value = /** @type {boolean} */ (reader.readBool());
                msg.setPriceTypeMarket(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.OrderConditional.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditional} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTargetId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getInsertDate();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getInsertTime();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getPrice();
    if (f !== 0.0) {
        writer.writeDouble(5, f);
    }
    f = message.getConditionPriceType();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
    f = message.getVolume();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
    f = message.getDirection();
    if (f !== 0) {
        writer.writeUint32(8, f);
    }
    f = message.getOffset();
    if (f !== 0) {
        writer.writeUint32(9, f);
    }
    f = message.getValidTime();
    if (f !== 0) {
        writer.writeUint32(10, f);
    }
    f = message.getState();
    if (f !== 0) {
        writer.writeUint32(11, f);
    }
    f = message.getStateDetail();
    if (f.length > 0) {
        writer.writeString(12, f);
    }
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(20, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(21, f);
    }
    f = message.getStamp();
    if (f !== 0) {
        writer.writeUint32(22, f);
    }
    f = message.getOperationType();
    if (f !== 0) {
        writer.writeUint32(23, f);
    }
    f = message.getOrderPriceType();
    if (f !== 0) {
        writer.writeUint32(24, f);
    }
    f = message.getOrderPrice();
    if (f !== 0.0) {
        writer.writeDouble(25, f);
    }
    f = message.getOrderType();
    if (f !== 0) {
        writer.writeUint32(27, f);
    }
    f = message.getSlPrice();
    if (f !== 0.0) {
        writer.writeDouble(28, f);
    }
    f = message.getTpPrice();
    if (f !== 0.0) {
        writer.writeDouble(29, f);
    }
    f = message.getPosDirection();
    if (f !== 0) {
        writer.writeInt32(30, f);
    }
    f = message.getUpdateDate();
    if (f.length > 0) {
        writer.writeString(31, f);
    }
    f = message.getUpdateTime();
    if (f.length > 0) {
        writer.writeString(32, f);
    }
    f = message.getPriceTypeMarket();
    if (f) {
        writer.writeBool(33, f);
    }
};
/**
 * optional string id = 1;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setId = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getTargetId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setTargetId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string insert_date = 3;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getInsertDate = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setInsertDate = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string insert_time = 4;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getInsertTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setInsertTime = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional double price = 5;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional uint32 condition_price_type = 6;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getConditionPriceType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setConditionPriceType = function (value) {
    jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint32 volume = 7;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getVolume = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setVolume = function (value) {
    jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint32 direction = 8;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setDirection = function (value) {
    jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional uint32 offset = 9;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getOffset = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setOffset = function (value) {
    jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional uint32 valid_time = 10;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getValidTime = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setValidTime = function (value) {
    jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional uint32 state = 11;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getState = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setState = function (value) {
    jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string state_detail = 12;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getStateDetail = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setStateDetail = function (value) {
    jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string broker = 20;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 20, value);
};
/**
 * optional string account = 21;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 21, value);
};
/**
 * optional uint32 stamp = 22;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getStamp = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setStamp = function (value) {
    jspb.Message.setProto3IntField(this, 22, value);
};
/**
 * optional uint32 operation_type = 23;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getOperationType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setOperationType = function (value) {
    jspb.Message.setProto3IntField(this, 23, value);
};
/**
 * optional uint32 order_price_type = 24;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getOrderPriceType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setOrderPriceType = function (value) {
    jspb.Message.setProto3IntField(this, 24, value);
};
/**
 * optional double order_price = 25;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getOrderPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 25, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setOrderPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 25, value);
};
/**
 * optional uint32 order_type = 27;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getOrderType = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setOrderType = function (value) {
    jspb.Message.setProto3IntField(this, 27, value);
};
/**
 * optional double sl_price = 28;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getSlPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 28, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setSlPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 28, value);
};
/**
 * optional double tp_price = 29;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getTpPrice = function () {
    return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 29, 0.0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setTpPrice = function (value) {
    jspb.Message.setProto3FloatField(this, 29, value);
};
/**
 * optional int32 pos_direction = 30;
 * @return {number}
 */
proto.ctpfront.proto.OrderConditional.prototype.getPosDirection = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};
/** @param {number} value */
proto.ctpfront.proto.OrderConditional.prototype.setPosDirection = function (value) {
    jspb.Message.setProto3IntField(this, 30, value);
};
/**
 * optional string update_date = 31;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getUpdateDate = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setUpdateDate = function (value) {
    jspb.Message.setProto3StringField(this, 31, value);
};
/**
 * optional string update_time = 32;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditional.prototype.getUpdateTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditional.prototype.setUpdateTime = function (value) {
    jspb.Message.setProto3StringField(this, 32, value);
};
/**
 * optional bool price_type_market = 33;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.ctpfront.proto.OrderConditional.prototype.getPriceTypeMarket = function () {
    return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 33, false));
};
/** @param {boolean} value */
proto.ctpfront.proto.OrderConditional.prototype.setPriceTypeMarket = function (value) {
    jspb.Message.setProto3BooleanField(this, 33, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.OrderConditionalReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.OrderConditionalReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.OrderConditionalReq.displayName = 'proto.ctpfront.proto.OrderConditionalReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.OrderConditionalReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.OrderConditionalReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionalReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.OrderConditionalReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            id: jspb.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionalReq}
 */
proto.ctpfront.proto.OrderConditionalReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.OrderConditionalReq;
    return proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionalReq}
 */
proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.OrderConditionalReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionalReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionalReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionalReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionalReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string id = 3;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionalReq.prototype.getId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionalReq.prototype.setId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.OrderConditionalRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.OrderConditionalRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.OrderConditionalRsp.displayName = 'proto.ctpfront.proto.OrderConditionalRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.OrderConditionalRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.OrderConditionalRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionalRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.OrderConditionalRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.OrderConditionalReq.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionalRsp}
 */
proto.ctpfront.proto.OrderConditionalRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.OrderConditionalRsp;
    return proto.ctpfront.proto.OrderConditionalRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionalRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionalRsp}
 */
proto.ctpfront.proto.OrderConditionalRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.OrderConditionalReq;
                reader.readMessage(value, proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.OrderConditionalRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.OrderConditionalRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionalRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.OrderConditionalRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.OrderConditionalRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.OrderConditionalRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.OrderConditionalRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.OrderConditionalRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional OrderConditionalReq data = 2;
 * @return {?proto.ctpfront.proto.OrderConditionalReq}
 */
proto.ctpfront.proto.OrderConditionalRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.OrderConditionalReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.OrderConditionalReq, 2));
};
/** @param {?proto.ctpfront.proto.OrderConditionalReq|undefined} value */
proto.ctpfront.proto.OrderConditionalRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.OrderConditionalRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.OrderConditionalRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.OrderConditionGetReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.OrderConditionGetReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.OrderConditionGetReq.displayName = 'proto.ctpfront.proto.OrderConditionGetReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.OrderConditionGetReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.OrderConditionGetReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionGetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.OrderConditionGetReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            startTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
            lastTime: jspb.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionGetReq}
 */
proto.ctpfront.proto.OrderConditionGetReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.OrderConditionGetReq;
    return proto.ctpfront.proto.OrderConditionGetReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionGetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionGetReq}
 */
proto.ctpfront.proto.OrderConditionGetReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setStartTime(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setLastTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.OrderConditionGetReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.OrderConditionGetReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionGetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.OrderConditionGetReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getStartTime();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getLastTime();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionGetReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionGetReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionGetReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionGetReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string start_time = 3;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionGetReq.prototype.getStartTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionGetReq.prototype.setStartTime = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_time = 4;
 * @return {string}
 */
proto.ctpfront.proto.OrderConditionGetReq.prototype.getLastTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.OrderConditionGetReq.prototype.setLastTime = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.OrderConditionGetRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.OrderConditionGetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.OrderConditionGetRsp.displayName = 'proto.ctpfront.proto.OrderConditionGetRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.OrderConditionGetRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.OrderConditionGetRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionGetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.OrderConditionGetRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.OrderConditional.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionGetRsp}
 */
proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.OrderConditionGetRsp;
    return proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionGetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionGetRsp}
 */
proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.OrderConditional;
                reader.readMessage(value, proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.OrderConditionGetRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionGetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.OrderConditionGetRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.OrderConditionGetRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional OrderConditional data = 2;
 * @return {?proto.ctpfront.proto.OrderConditional}
 */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.OrderConditional} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.OrderConditional, 2));
};
/** @param {?proto.ctpfront.proto.OrderConditional|undefined} value */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.OrderConditionGetRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.OrderConditionGetRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubConditionList = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SubConditionList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubConditionList.displayName = 'proto.ctpfront.proto.SubConditionList';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubConditionList.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubConditionList.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubConditionList} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubConditionList.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubConditionList}
 */
proto.ctpfront.proto.SubConditionList.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubConditionList;
    return proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubConditionList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubConditionList}
 */
proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubConditionList.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubConditionList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.SubConditionList.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.SubConditionList.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.SubConditionList.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.SubConditionList.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.SubConditionListRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.SubConditionListRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.SubConditionListRsp.displayName = 'proto.ctpfront.proto.SubConditionListRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.SubConditionListRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.SubConditionListRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubConditionListRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.SubConditionListRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.SubConditionList.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubConditionListRsp}
 */
proto.ctpfront.proto.SubConditionListRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.SubConditionListRsp;
    return proto.ctpfront.proto.SubConditionListRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubConditionListRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubConditionListRsp}
 */
proto.ctpfront.proto.SubConditionListRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.SubConditionList;
                reader.readMessage(value, proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.SubConditionListRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.SubConditionListRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubConditionListRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.SubConditionListRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.SubConditionListRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.SubConditionListRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.SubConditionListRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SubConditionListRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional SubConditionList data = 2;
 * @return {?proto.ctpfront.proto.SubConditionList}
 */
proto.ctpfront.proto.SubConditionListRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.SubConditionList} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.SubConditionList, 2));
};
/** @param {?proto.ctpfront.proto.SubConditionList|undefined} value */
proto.ctpfront.proto.SubConditionListRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.SubConditionListRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.SubConditionListRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.ConditionOrderRecordGetReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.ConditionOrderRecordGetReq.displayName = 'proto.ctpfront.proto.ConditionOrderRecordGetReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.ConditionOrderRecordGetReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.ConditionOrderRecordGetReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            chdaccountid: jspb.Message.getFieldWithDefault(msg, 2, ""),
            conId: jspb.Message.getFieldWithDefault(msg, 3, ""),
            startTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
            endTime: jspb.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetReq}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.ConditionOrderRecordGetReq;
    return proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetReq}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setChdaccountid(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setConId(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setStartTime(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setEndTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.ConditionOrderRecordGetReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getChdaccountid();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getConId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getStartTime();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getEndTime();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
};
/**
 * optional string chdaccountid = 2;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getChdaccountid = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setChdaccountid = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string con_id = 3;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getConId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setConId = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string start_time = 4;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getStartTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setStartTime = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string end_time = 5;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getEndTime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setEndTime = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.ConditionOrderRecord = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.ConditionOrderRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.ConditionOrderRecord.displayName = 'proto.ctpfront.proto.ConditionOrderRecord';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.ConditionOrderRecord.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.ConditionOrderRecord.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecord} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.ConditionOrderRecord.toObject = function (includeInstance, msg) {
        var f, obj = {
            id: jspb.Message.getFieldWithDefault(msg, 1, 0),
            conId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            operation: jspb.Message.getFieldWithDefault(msg, 3, 0),
            state: jspb.Message.getFieldWithDefault(msg, 4, 0),
            updateip: jspb.Message.getFieldWithDefault(msg, 6, ""),
            updatemac: jspb.Message.getFieldWithDefault(msg, 7, ""),
            datetime: jspb.Message.getFieldWithDefault(msg, 8, ""),
            description: jspb.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecord}
 */
proto.ctpfront.proto.ConditionOrderRecord.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.ConditionOrderRecord;
    return proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecord}
 */
proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setConId(value);
                break;
            case 3:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setOperation(value);
                break;
            case 4:
                var value = /** @type {number} */ (reader.readInt32());
                msg.setState(value);
                break;
            case 6:
                var value = /** @type {string} */ (reader.readString());
                msg.setUpdateip(value);
                break;
            case 7:
                var value = /** @type {string} */ (reader.readString());
                msg.setUpdatemac(value);
                break;
            case 8:
                var value = /** @type {string} */ (reader.readString());
                msg.setDatetime(value);
                break;
            case 9:
                var value = /** @type {string} */ (reader.readString());
                msg.setDescription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) {
        writer.writeInt32(1, f);
    }
    f = message.getConId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getOperation();
    if (f !== 0) {
        writer.writeInt32(3, f);
    }
    f = message.getState();
    if (f !== 0) {
        writer.writeInt32(4, f);
    }
    f = message.getUpdateip();
    if (f.length > 0) {
        writer.writeString(6, f);
    }
    f = message.getUpdatemac();
    if (f.length > 0) {
        writer.writeString(7, f);
    }
    f = message.getDatetime();
    if (f.length > 0) {
        writer.writeString(8, f);
    }
    f = message.getDescription();
    if (f.length > 0) {
        writer.writeString(9, f);
    }
};
/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getId = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};
/** @param {number} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setId = function (value) {
    jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string con_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getConId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setConId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 operation = 3;
 * @return {number}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getOperation = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};
/** @param {number} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setOperation = function (value) {
    jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 state = 4;
 * @return {number}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getState = function () {
    return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};
/** @param {number} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setState = function (value) {
    jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string updateip = 6;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getUpdateip = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setUpdateip = function (value) {
    jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string updatemac = 7;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getUpdatemac = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setUpdatemac = function (value) {
    jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string datetime = 8;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getDatetime = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setDatetime = function (value) {
    jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string description = 9;
 * @return {string}
 */
proto.ctpfront.proto.ConditionOrderRecord.prototype.getDescription = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};
/** @param {string} value */
proto.ctpfront.proto.ConditionOrderRecord.prototype.setDescription = function (value) {
    jspb.Message.setProto3StringField(this, 9, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.ConditionOrderRecordGetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.ConditionOrderRecordGetRsp.displayName = 'proto.ctpfront.proto.ConditionOrderRecordGetRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.ConditionOrderRecordGetRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.ConditionOrderRecordGetRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.ConditionOrderRecord.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetRsp}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.ConditionOrderRecordGetRsp;
    return proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetRsp}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.ConditionOrderRecord;
                reader.readMessage(value, proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.ConditionOrderRecordGetRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional ConditionOrderRecord data = 2;
 * @return {?proto.ctpfront.proto.ConditionOrderRecord}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.ConditionOrderRecord} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.ConditionOrderRecord, 2));
};
/** @param {?proto.ctpfront.proto.ConditionOrderRecord|undefined} value */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TradeAccountPasswdUpdateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TradeAccountPasswdUpdateReq.displayName = 'proto.ctpfront.proto.TradeAccountPasswdUpdateReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            account: jspb.Message.getFieldWithDefault(msg, 2, ""),
            oldPasswd: jspb.Message.getFieldWithDefault(msg, 3, ""),
            newPasswd: jspb.Message.getFieldWithDefault(msg, 4, ""),
            currencyId: jspb.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TradeAccountPasswdUpdateReq;
    return proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setAccount(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setOldPasswd(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setNewPasswd(value);
                break;
            case 5:
                var value = /** @type {string} */ (reader.readString());
                msg.setCurrencyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getAccount();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getOldPasswd();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getNewPasswd();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getCurrencyId();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account = 2;
 * @return {string}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getAccount = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setAccount = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string old_passwd = 3;
 * @return {string}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getOldPasswd = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setOldPasswd = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string new_passwd = 4;
 * @return {string}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getNewPasswd = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setNewPasswd = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string currency_id = 5;
 * @return {string}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getCurrencyId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};
/** @param {string} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setCurrencyId = function (value) {
    jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.TradeAccountPasswdUpdateRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.displayName = 'proto.ctpfront.proto.TradeAccountPasswdUpdateRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.TradeAccountPasswdUpdateRsp;
    return proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.TradeAccountPasswdUpdateReq;
                reader.readMessage(value, proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional TradeAccountPasswdUpdateReq data = 2;
 * @return {?proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.TradeAccountPasswdUpdateReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.TradeAccountPasswdUpdateReq, 2));
};
/** @param {?proto.ctpfront.proto.TradeAccountPasswdUpdateReq|undefined} value */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.UserPasswdUpdateReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.UserPasswdUpdateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.UserPasswdUpdateReq.displayName = 'proto.ctpfront.proto.UserPasswdUpdateReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.UserPasswdUpdateReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.UserPasswdUpdateReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.UserPasswdUpdateReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
            userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            oldPasswd: jspb.Message.getFieldWithDefault(msg, 3, ""),
            newPasswd: jspb.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateReq}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.UserPasswdUpdateReq;
    return proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateReq}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setBroker(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setOldPasswd(value);
                break;
            case 4:
                var value = /** @type {string} */ (reader.readString());
                msg.setNewPasswd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getBroker();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getUserId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getOldPasswd();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getNewPasswd();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
};
/**
 * optional string broker = 1;
 * @return {string}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getBroker = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setBroker = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getUserId = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setUserId = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string old_passwd = 3;
 * @return {string}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getOldPasswd = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setOldPasswd = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string new_passwd = 4;
 * @return {string}
 */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getNewPasswd = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};
/** @param {string} value */
proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setNewPasswd = function (value) {
    jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.UserPasswdUpdateRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.UserPasswdUpdateRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.UserPasswdUpdateRsp.displayName = 'proto.ctpfront.proto.UserPasswdUpdateRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.UserPasswdUpdateRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.UserPasswdUpdateRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.UserPasswdUpdateReq.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateRsp}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.UserPasswdUpdateRsp;
    return proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateRsp}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 2:
                var value = new proto.ctpfront.proto.UserPasswdUpdateReq;
                reader.readMessage(value, proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.UserPasswdUpdateRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getError();
    if (f != null) {
        writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(2, f, proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter);
    }
};
/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 1));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional UserPasswdUpdateReq data = 2;
 * @return {?proto.ctpfront.proto.UserPasswdUpdateReq}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.UserPasswdUpdateReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.UserPasswdUpdateReq, 2));
};
/** @param {?proto.ctpfront.proto.UserPasswdUpdateReq|undefined} value */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Word = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.Word, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Word.displayName = 'proto.ctpfront.proto.Word';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Word.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Word.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Word} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Word.toObject = function (includeInstance, msg) {
        var f, obj = {
            word: jspb.Message.getFieldWithDefault(msg, 1, ""),
            lang: jspb.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Word}
 */
proto.ctpfront.proto.Word.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Word;
    return proto.ctpfront.proto.Word.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Word} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Word}
 */
proto.ctpfront.proto.Word.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setWord(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setLang(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Word.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Word.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Word} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Word.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getWord();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getLang();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
};
/**
 * optional string word = 1;
 * @return {string}
 */
proto.ctpfront.proto.Word.prototype.getWord = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Word.prototype.setWord = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string lang = 2;
 * @return {string}
 */
proto.ctpfront.proto.Word.prototype.getLang = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.Word.prototype.setLang = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.Dictionary = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.ctpfront.proto.Dictionary.repeatedFields_, null);
};
goog.inherits(proto.ctpfront.proto.Dictionary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.Dictionary.displayName = 'proto.ctpfront.proto.Dictionary';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ctpfront.proto.Dictionary.repeatedFields_ = [1];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.Dictionary.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.Dictionary.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Dictionary} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.Dictionary.toObject = function (includeInstance, msg) {
        var f, obj = {
            dataList: jspb.Message.toObjectList(msg.getDataList(), proto.ctpfront.proto.Word.toObject, includeInstance)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Dictionary}
 */
proto.ctpfront.proto.Dictionary.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.Dictionary;
    return proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Dictionary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Dictionary}
 */
proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new proto.ctpfront.proto.Word;
                reader.readMessage(value, proto.ctpfront.proto.Word.deserializeBinaryFromReader);
                msg.addData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.Dictionary.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.Dictionary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Dictionary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.Dictionary.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getDataList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.ctpfront.proto.Word.serializeBinaryToWriter);
    }
};
/**
 * repeated Word data = 1;
 * @return {!Array.<!proto.ctpfront.proto.Word>}
 */
proto.ctpfront.proto.Dictionary.prototype.getDataList = function () {
    return /** @type{!Array.<!proto.ctpfront.proto.Word>} */ (jspb.Message.getRepeatedWrapperField(this, proto.ctpfront.proto.Word, 1));
};
/** @param {!Array.<!proto.ctpfront.proto.Word>} value */
proto.ctpfront.proto.Dictionary.prototype.setDataList = function (value) {
    jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.ctpfront.proto.Word=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ctpfront.proto.Word}
 */
proto.ctpfront.proto.Dictionary.prototype.addData = function (opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ctpfront.proto.Word, opt_index);
};
proto.ctpfront.proto.Dictionary.prototype.clearDataList = function () {
    this.setDataList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.LangPack = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.LangPack, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.LangPack.displayName = 'proto.ctpfront.proto.LangPack';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.LangPack.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.LangPack.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LangPack} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.LangPack.toObject = function (includeInstance, msg) {
        var f, obj = {
            dictionary: (f = msg.getDictionary()) && proto.ctpfront.proto.Dictionary.toObject(includeInstance, f),
            manualSite: jspb.Message.getFieldWithDefault(msg, 2, ""),
            timestamp: jspb.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LangPack}
 */
proto.ctpfront.proto.LangPack.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.LangPack;
    return proto.ctpfront.proto.LangPack.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LangPack} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LangPack}
 */
proto.ctpfront.proto.LangPack.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new proto.ctpfront.proto.Dictionary;
                reader.readMessage(value, proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader);
                msg.setDictionary(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setManualSite(value);
                break;
            case 3:
                var value = /** @type {string} */ (reader.readString());
                msg.setTimestamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.LangPack.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.LangPack.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LangPack} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.LangPack.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getDictionary();
    if (f != null) {
        writer.writeMessage(1, f, proto.ctpfront.proto.Dictionary.serializeBinaryToWriter);
    }
    f = message.getManualSite();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getTimestamp();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
};
/**
 * optional Dictionary dictionary = 1;
 * @return {?proto.ctpfront.proto.Dictionary}
 */
proto.ctpfront.proto.LangPack.prototype.getDictionary = function () {
    return /** @type{?proto.ctpfront.proto.Dictionary} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.Dictionary, 1));
};
/** @param {?proto.ctpfront.proto.Dictionary|undefined} value */
proto.ctpfront.proto.LangPack.prototype.setDictionary = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.LangPack.prototype.clearDictionary = function () {
    this.setDictionary(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.LangPack.prototype.hasDictionary = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional string manual_site = 2;
 * @return {string}
 */
proto.ctpfront.proto.LangPack.prototype.getManualSite = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LangPack.prototype.setManualSite = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string timestamp = 3;
 * @return {string}
 */
proto.ctpfront.proto.LangPack.prototype.getTimestamp = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};
/** @param {string} value */
proto.ctpfront.proto.LangPack.prototype.setTimestamp = function (value) {
    jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.GetLangReq = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.GetLangReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.GetLangReq.displayName = 'proto.ctpfront.proto.GetLangReq';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.GetLangReq.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.GetLangReq.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.GetLangReq.toObject = function (includeInstance, msg) {
        var f, obj = {
            module: jspb.Message.getFieldWithDefault(msg, 1, ""),
            lang: jspb.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangReq}
 */
proto.ctpfront.proto.GetLangReq.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.GetLangReq;
    return proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangReq}
 */
proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setModule(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setLang(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.GetLangReq.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getModule();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getLang();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
};
/**
 * optional string module = 1;
 * @return {string}
 */
proto.ctpfront.proto.GetLangReq.prototype.getModule = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.GetLangReq.prototype.setModule = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string lang = 2;
 * @return {string}
 */
proto.ctpfront.proto.GetLangReq.prototype.getLang = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.GetLangReq.prototype.setLang = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.GetLangRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.GetLangRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.GetLangRsp.displayName = 'proto.ctpfront.proto.GetLangRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.GetLangRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.GetLangRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.GetLangRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            request: (f = msg.getRequest()) && proto.ctpfront.proto.GetLangReq.toObject(includeInstance, f),
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.LangPack.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangRsp}
 */
proto.ctpfront.proto.GetLangRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.GetLangRsp;
    return proto.ctpfront.proto.GetLangRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangRsp}
 */
proto.ctpfront.proto.GetLangRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new proto.ctpfront.proto.GetLangReq;
                reader.readMessage(value, proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader);
                msg.setRequest(value);
                break;
            case 2:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 3:
                var value = new proto.ctpfront.proto.LangPack;
                reader.readMessage(value, proto.ctpfront.proto.LangPack.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.GetLangRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.GetLangRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.GetLangRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getRequest();
    if (f != null) {
        writer.writeMessage(1, f, proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter);
    }
    f = message.getError();
    if (f != null) {
        writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(3, f, proto.ctpfront.proto.LangPack.serializeBinaryToWriter);
    }
};
/**
 * optional GetLangReq request = 1;
 * @return {?proto.ctpfront.proto.GetLangReq}
 */
proto.ctpfront.proto.GetLangRsp.prototype.getRequest = function () {
    return /** @type{?proto.ctpfront.proto.GetLangReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.GetLangReq, 1));
};
/** @param {?proto.ctpfront.proto.GetLangReq|undefined} value */
proto.ctpfront.proto.GetLangRsp.prototype.setRequest = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.GetLangRsp.prototype.clearRequest = function () {
    this.setRequest(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangRsp.prototype.hasRequest = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.GetLangRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.GetLangRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.GetLangRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * optional LangPack data = 3;
 * @return {?proto.ctpfront.proto.LangPack}
 */
proto.ctpfront.proto.GetLangRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.LangPack} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.LangPack, 3));
};
/** @param {?proto.ctpfront.proto.LangPack|undefined} value */
proto.ctpfront.proto.GetLangRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 3, value);
};
proto.ctpfront.proto.GetLangRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.License = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.License, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.License.displayName = 'proto.ctpfront.proto.License';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.License.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.License.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.License} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.License.toObject = function (includeInstance, msg) {
        var f, obj = {
            license: jspb.Message.getFieldWithDefault(msg, 1, ""),
            timestamp: jspb.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.License}
 */
proto.ctpfront.proto.License.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.License;
    return proto.ctpfront.proto.License.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.License} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.License}
 */
proto.ctpfront.proto.License.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = /** @type {string} */ (reader.readString());
                msg.setLicense(value);
                break;
            case 2:
                var value = /** @type {string} */ (reader.readString());
                msg.setTimestamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.License.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.License.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.License} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.License.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getLicense();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getTimestamp();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
};
/**
 * optional string license = 1;
 * @return {string}
 */
proto.ctpfront.proto.License.prototype.getLicense = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};
/** @param {string} value */
proto.ctpfront.proto.License.prototype.setLicense = function (value) {
    jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string timestamp = 2;
 * @return {string}
 */
proto.ctpfront.proto.License.prototype.getTimestamp = function () {
    return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};
/** @param {string} value */
proto.ctpfront.proto.License.prototype.setTimestamp = function (value) {
    jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ctpfront.proto.GetLangLicenseRsp = function (opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ctpfront.proto.GetLangLicenseRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    proto.ctpfront.proto.GetLangLicenseRsp.displayName = 'proto.ctpfront.proto.GetLangLicenseRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ctpfront.proto.GetLangLicenseRsp.prototype.toObject = function (opt_includeInstance) {
        return proto.ctpfront.proto.GetLangLicenseRsp.toObject(opt_includeInstance, this);
    };
    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangLicenseRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ctpfront.proto.GetLangLicenseRsp.toObject = function (includeInstance, msg) {
        var f, obj = {
            request: (f = msg.getRequest()) && proto.ctpfront.proto.GetLangReq.toObject(includeInstance, f),
            error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
            data: (f = msg.getData()) && proto.ctpfront.proto.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangLicenseRsp}
 */
proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinary = function (bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.ctpfront.proto.GetLangLicenseRsp;
    return proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangLicenseRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangLicenseRsp}
 */
proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinaryFromReader = function (msg, reader) {
    while (reader.nextField()) {
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
            case 1:
                var value = new proto.ctpfront.proto.GetLangReq;
                reader.readMessage(value, proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader);
                msg.setRequest(value);
                break;
            case 2:
                var value = new Object_pb.Error;
                reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
                msg.setError(value);
                break;
            case 3:
                var value = new proto.ctpfront.proto.License;
                reader.readMessage(value, proto.ctpfront.proto.License.deserializeBinaryFromReader);
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.serializeBinary = function () {
    var writer = new jspb.BinaryWriter();
    proto.ctpfront.proto.GetLangLicenseRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangLicenseRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ctpfront.proto.GetLangLicenseRsp.serializeBinaryToWriter = function (message, writer) {
    var f = undefined;
    f = message.getRequest();
    if (f != null) {
        writer.writeMessage(1, f, proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter);
    }
    f = message.getError();
    if (f != null) {
        writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
    }
    f = message.getData();
    if (f != null) {
        writer.writeMessage(3, f, proto.ctpfront.proto.License.serializeBinaryToWriter);
    }
};
/**
 * optional GetLangReq request = 1;
 * @return {?proto.ctpfront.proto.GetLangReq}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.getRequest = function () {
    return /** @type{?proto.ctpfront.proto.GetLangReq} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.GetLangReq, 1));
};
/** @param {?proto.ctpfront.proto.GetLangReq|undefined} value */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.setRequest = function (value) {
    jspb.Message.setWrapperField(this, 1, value);
};
proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearRequest = function () {
    this.setRequest(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasRequest = function () {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.getError = function () {
    return /** @type{?proto.proto.Error} */ (jspb.Message.getWrapperField(this, Object_pb.Error, 2));
};
/** @param {?proto.proto.Error|undefined} value */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.setError = function (value) {
    jspb.Message.setWrapperField(this, 2, value);
};
proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearError = function () {
    this.setError(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasError = function () {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * optional License data = 3;
 * @return {?proto.ctpfront.proto.License}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.getData = function () {
    return /** @type{?proto.ctpfront.proto.License} */ (jspb.Message.getWrapperField(this, proto.ctpfront.proto.License, 3));
};
/** @param {?proto.ctpfront.proto.License|undefined} value */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.setData = function (value) {
    jspb.Message.setWrapperField(this, 3, value);
};
proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearData = function () {
    this.setData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasData = function () {
    return jspb.Message.getField(this, 3) != null;
};
goog.object.extend(exports, proto.ctpfront.proto);



//////////////////
// WEBPACK FOOTER
// ./static/js/proto/CtpFront_pb.js
// module id = NNz/
// module chunks = 2